var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* tslint:disable */
/* eslint:disable */
/**
 * @typedef {string} Url
 */
/**
 * @typedef {string} GUID
 */
/**
 * @typedef {number} DateTime
 */
var dummy;
var defaultConfig = { endpoint: 'photo-users' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 65 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'photo-users' });
    }
    ;
    /**
    * @typedef {Object} proGallerySettingsLoadedParams
    * @property {string} category - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - null
    **/
    /**
     * Name: pro gallery settings loaded. Evid: 403.
     * Event description: the user opened the pro gallery settings.
    
     * category - Type: string.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string.
     * @param {proGallerySettingsLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.proGallerySettingsLoaded = function (params) {
        return this.bi.log(__assign({ evid: 403 }, params));
    };
    /**
    * @typedef {Object} photoAlbumDashboardNavigation180Params
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - dashboard category - My Albums/Overview
    **/
    /**
     * Name: photo album --> dashboard navigation. Evid: 180.
     * Event description: users navigates in dashboard.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: dashboard category - My Albums/Overview
     * @param {photoAlbumDashboardNavigation180Params} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumDashboardNavigation180 = function (params) {
        return this.bi.log(__assign({ evid: 180 }, params));
    };
    /**
    * @typedef {Object} expandModeDoneParams
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - photo/store/pro
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    **/
    /**
     * Name: expand mode-->done. Evid: 704.
     * Event description: click on done from expand mode settings.
    
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: photo/store/pro
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     * @param {expandModeDoneParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.expandModeDone = function (params) {
        return this.bi.log(__assign({ evid: 704 }, params));
    };
    /**
    * @typedef {Object} oaManageMediaDeleteItemParams
    * @property {string} app_id - []
    * @property {number} numberOfItems - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - list or edit
    **/
    /**
     * Name: OA Manage media - Delete Item. Evid: 533.
     * Event description: user deletes an item in manage media.
    
     * app_id - Type: string. Desc: []
     *
     * numberOfItems - Type: numeric. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: list or edit
     * @param {oaManageMediaDeleteItemParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageMediaDeleteItem = function (params) {
        return this.bi.log(__assign({ evid: 533 }, params));
    };
    /**
    * @typedef {Object} clickLoginProofingSettingsParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} screenName - bo/etc...
    **/
    /**
     * Name: Click Login Proofing Settings. Evid: 258.
     * Event description: when the user click login setting.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * screenName - Type: string. Desc: bo/etc...
     * @param {clickLoginProofingSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickLoginProofingSettings = function (params) {
        return this.bi.log(__assign({ evid: 258 }, params));
    };
    /**
    * @typedef {Object} editorCutImagesParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_cut_images. Evid: 139.
     * Event description: editor_cut_images.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * set_id - Type: string. Desc: -
     * @param {editorCutImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorCutImages = function (params) {
        return this.bi.log(__assign({ evid: 139 }, params));
    };
    /**
    * @typedef {Object} addToGogParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: add_to_gog. Evid: 156.
     * Event description: add_to_gog (after publishing album site).
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {addToGogParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.addToGog = function (params) {
        return this.bi.log(__assign({ evid: 156 }, params));
    };
    /**
    * @typedef {Object} searchAlbumParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} page_name - page name
    * @property {string} search_term - not in use
    **/
    /**
     * Name: album_list-->navigation. Evid: 103.
     * Event description: search_album.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * page_name - Type: string. Desc: page name
     *
     * search_term - Type: string. Desc: not in use
     * @param {searchAlbumParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.searchAlbum = function (params) {
        return this.bi.log(__assign({ evid: 103 }, params));
    };
    /**
    * @typedef {Object} editCollectionParams
    * @property {string} albumID - album_id
    * @property {string} button_name - edit / collection settings
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Edit Collection. Evid: 225.
     * Event description: arrived when the user edit collection.
    
     * albumID - Type: string. Desc: album_id
     *
     * button_name - Type: string. Desc: edit / collection settings
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {editCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editCollection = function (params) {
        return this.bi.log(__assign({ evid: 225 }, params));
    };
    /**
    * @typedef {Object} editorNewSetParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_new_set. Evid: 122.
     * Event description: editor_new_set.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {editorNewSetParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorNewSet = function (params) {
        return this.bi.log(__assign({ evid: 122 }, params));
    };
    /**
    * @typedef {Object} viewItemInTheCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {string} item_id - id of the chosen item
    * @property {GUID} biToken - null
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: View Item In The Collection. Evid: 221.
     * Event description: when user view item in the collection from the bzm.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * item_id - Type: string. Desc: id of the chosen item
     *
     * biToken - Type: guid.
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {viewItemInTheCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.viewItemInTheCollection = function (params) {
        return this.bi.log(__assign({ evid: 221 }, params));
    };
    /**
    * @typedef {Object} navigationInCollectionMemberAreaParams
    * @property {string} albumID - album_id
    * @property {string} category - sellected_media/discussions/members/about
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Navigation In Collection Member Area. Evid: 234.
     * Event description: when user navigation In collection member area.
    
     * albumID - Type: string. Desc: album_id
     *
     * category - Type: string. Desc: sellected_media/discussions/members/about
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {navigationInCollectionMemberAreaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.navigationInCollectionMemberArea = function (params) {
        return this.bi.log(__assign({ evid: 234 }, params));
    };
    /**
    * @typedef {Object} albumsListViewParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_albums - number of albums
    **/
    /**
     * Name: albums_list_view. Evid: 100.
     * Event description: albums_list_view- page appear.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_albums - Type: numeric. Desc: number of albums
     * @param {albumsListViewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.albumsListView = function (params) {
        return this.bi.log(__assign({ evid: 100 }, params));
    };
    /**
    * @typedef {Object} clickOnActionFromCollectionItemActionMenuParams
    * @property {string} albumID - album_id
    * @property {string} button_name - action name
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {string} item_id - id of the chosen item
    * @property {GUID} biToken - null
    * @property {string} origin - bzm/member area
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click on Action from Collection Item Action Menu. Evid: 219.
     * Event description: when user click on an action from the item menu.
    
     * albumID - Type: string. Desc: album_id
     *
     * button_name - Type: string. Desc: action name
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * item_id - Type: string. Desc: id of the chosen item
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: bzm/member area
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnActionFromCollectionItemActionMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnActionFromCollectionItemActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 219 }, params));
    };
    /**
    * @typedef {Object} wizardNextParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} screen_clicked - {types,details,layouts,done}
    * @property {string} selection - album type or layout type
    **/
    /**
     * Name: wizard_next. Evid: 114.
     * Event description: wizard_next.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * screen_clicked - Type: string. Desc: {types,details,layouts,done}
     *
     * selection - Type: string. Desc: album type or layout type
     * @param {wizardNextParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardNext = function (params) {
        return this.bi.log(__assign({ evid: 114 }, params));
    };
    /**
    * @typedef {Object} editorDeleteImagesParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_delete_images. Evid: 141.
     * Event description: editor_delete_images.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * set_id - Type: string. Desc: -
     * @param {editorDeleteImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorDeleteImages = function (params) {
        return this.bi.log(__assign({ evid: 141 }, params));
    };
    /**
    * @typedef {Object} saveInSantaFailedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {string} error_code - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: save_in_santa_failed. Evid: 163.
     * Event description: save_in_santa_failed.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * error_code - Type: string. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {saveInSantaFailedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.saveInSantaFailed = function (params) {
        return this.bi.log(__assign({ evid: 163 }, params));
    };
    /**
    * @typedef {Object} wizardStepDetailsParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} site_name - -
    **/
    /**
     * Name: wizard_step_details. Evid: 110.
     * Event description: wizard_step_details - site name saved on blur.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * site_name - Type: string. Desc: -
     * @param {wizardStepDetailsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardStepDetails = function (params) {
        return this.bi.log(__assign({ evid: 110 }, params));
    };
    /**
    * @typedef {Object} editorUploadMorePhotosParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_images - -
    * @property {string} photo_site_id - -
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_upload_more_photos. Evid: 120.
     * Event description: editor_upload_more_photos.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_images - Type: numeric. Desc: -
     *
     * photo_site_id - Type: string. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {editorUploadMorePhotosParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorUploadMorePhotos = function (params) {
        return this.bi.log(__assign({ evid: 120 }, params));
    };
    /**
    * @typedef {Object} editAlbumParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    **/
    /**
     * Name: edit_album. Evid: 105.
     * Event description: edit_album.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     * @param {editAlbumParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editAlbum = function (params) {
        return this.bi.log(__assign({ evid: 105 }, params));
    };
    /**
    * @typedef {Object} createCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} origin - collection settings/ new collection / LiveSite
    * @property {string} params - collection params
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Create Collection. Evid: 198.
     * Event description: when user click to create collection.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: collection settings/ new collection / LiveSite
     *
     * params - Type: string. Desc: collection params
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {createCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.createCollection = function (params) {
        return this.bi.log(__assign({ evid: 198 }, params));
    };
    /**
    * @typedef {Object} oaManageAlbumActionParams
    * @property {string} actionName - action clicked
    * @property {GUID} album_id - []
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    **/
    /**
     * Name: OA Manage Album Action. Evid: 273.
     * Event description: user clicks an action in the manage albums screen.
    
     * actionName - Type: string. Desc: action clicked
     *
     * album_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     * @param {oaManageAlbumActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageAlbumAction = function (params) {
        return this.bi.log(__assign({ evid: 273 }, params));
    };
    /**
    * @typedef {Object} artStoreDashboardNavigationParams
    * @property {string} app_id - []
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - orders/licenses/payment/bus info
    **/
    /**
     * Name: manage store --> click. Evid: 727.
     * Event description: user clicks on manage store.
    
     * app_id - Type: string. Desc: []
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: orders/licenses/payment/bus info
     * @param {artStoreDashboardNavigationParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStoreDashboardNavigation = function (params) {
        return this.bi.log(__assign({ evid: 727 }, params));
    };
    /**
    * @typedef {Object} editorTopMenuParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} selection - {main,photos,design,details,settings,help,publish}
    **/
    /**
     * Name: editor_top_menu. Evid: 128.
     * Event description: editor_top_menu.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * selection - Type: string. Desc: {main,photos,design,details,settings,help,publish}
     * @param {editorTopMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorTopMenu = function (params) {
        return this.bi.log(__assign({ evid: 128 }, params));
    };
    /**
    * @typedef {Object} manageStoreBusinessInfoParams
    * @property {string} app_id - []
    * @property {string} field - field name
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - gallery_id
    * @property {string} value - value entered
    **/
    /**
     * Name: manage store -> business info. Evid: 722.
     * Event description: 1.business name 2. email.
    
     * app_id - Type: string. Desc: []
     *
     * field - Type: string. Desc: field name
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid. Desc: gallery_id
     *
     * value - Type: string. Desc: value entered
     * @param {manageStoreBusinessInfoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageStoreBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 722 }, params));
    };
    /**
    * @typedef {Object} hintClickParams
    * @property {string} albumID - []
    * @property {string} buttonName - exit/check it out
    * @property {string} hintName - settings/publish
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} screenName - builder
    **/
    /**
     * Name: Hint Click. Evid: 236.
     * Event description: user click on button in a hint.
    
     * albumID - Type: string. Desc: []
     *
     * buttonName - Type: string. Desc: exit/check it out
     *
     * hintName - Type: string. Desc: settings/publish
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * screenName - Type: string. Desc: builder
     * @param {hintClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.hintClick = function (params) {
        return this.bi.log(__assign({ evid: 236 }, params));
    };
    /**
    * @typedef {Object} photoAlbumSettingsChangeParams
    * @property {string} category - []
    * @property {string} control_name - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} value - text/number/toggle
    **/
    /**
     * Name: photo album-->settings-->change. Evid: 201.
     * Event description: change of the settings.
    
     * category - Type: string. Desc: []
     *
     * control_name - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * value - Type: string. Desc: text/number/toggle
     * @param {photoAlbumSettingsChangeParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumSettingsChange = function (params) {
        return this.bi.log(__assign({ evid: 201 }, params));
    };
    /**
    * @typedef {Object} viewPublishedSiteParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    **/
    /**
     * Name: view_published_site. Evid: 108.
     * Event description: view_published_site.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     * @param {viewPublishedSiteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.viewPublishedSite = function (params) {
        return this.bi.log(__assign({ evid: 108 }, params));
    };
    /**
    * @typedef {Object} clientErrorParams
    * @property {GUID} app_site_id - -
    * @property {string} description - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: client_error. Evid: 148.
     * Event description: client_error.
    
     * app_site_id - Type: guid. Desc: -
     *
     * description - Type: string. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {clientErrorParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clientError = function (params) {
        return this.bi.log(__assign({ evid: 148 }, params));
    };
    /**
    * @typedef {Object} oaManageMediaReplaceItemParams
    * @property {string} app_id - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} source - []
    * @property {string} stage - click (on replace icon), source, choose (item), upload (successful)
    **/
    /**
     * Name: OA Manage media - Replace item. Evid: 531.
     * Event description: user click to replace item in manage media.
    
     * app_id - Type: string. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: []
     *
     * stage - Type: string. Desc: click (on replace icon), source, choose (item), upload (successful)
     * @param {oaManageMediaReplaceItemParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageMediaReplaceItem = function (params) {
        return this.bi.log(__assign({ evid: 531 }, params));
    };
    /**
    * @typedef {Object} editorPasteImagesParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_paste_images. Evid: 142.
     * Event description: editor_paste_images.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * set_id - Type: string. Desc: -
     * @param {editorPasteImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorPasteImages = function (params) {
        return this.bi.log(__assign({ evid: 142 }, params));
    };
    /**
    * @typedef {Object} organizeMediaReplaceImageParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} itemId - []
    * @property {GUID} biToken - null
    * @property {string} type - video/image..
    **/
    /**
     * Name: Organize Media - Replace Image. Evid: 423.
     * Event description: user clicks on replace image in the organize media window.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * itemId - Type: string. Desc: []
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: video/image..
     * @param {organizeMediaReplaceImageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.organizeMediaReplaceImage = function (params) {
        return this.bi.log(__assign({ evid: 423 }, params));
    };
    /**
    * @typedef {Object} watermarkSettingsParams
    * @property {string} control_name - null
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    * @property {string} value - null
    **/
    /**
     * Name: watermark-->settings. Evid: 705.
     * Event description: change watermark settings.
    
     * control_name - Type: string.
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     *
     * value - Type: string.
     * @param {watermarkSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.watermarkSettings = function (params) {
        return this.bi.log(__assign({ evid: 705 }, params));
    };
    /**
    * @typedef {Object} publishInAlbumsFailedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {string} error_code - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: publish_in_albums_failed. Evid: 166.
     * Event description: publish_in_albums_failed.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * error_code - Type: string. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {publishInAlbumsFailedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.publishInAlbumsFailed = function (params) {
        return this.bi.log(__assign({ evid: 166 }, params));
    };
    /**
    * @typedef {Object} editorDeletePhotoParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_delete_photo. Evid: 121.
     * Event description: editor_delete_photo.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {editorDeletePhotoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorDeletePhoto = function (params) {
        return this.bi.log(__assign({ evid: 121 }, params));
    };
    /**
    * @typedef {Object} settingsTabClickedParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} tab_name - {layout,design,my_albums}
    **/
    /**
     * Name: settings_tab_clicked. Evid: 152.
     * Event description: settings_tab_clicked.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * tab_name - Type: string. Desc: {layout,design,my_albums}
     * @param {settingsTabClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsTabClicked = function (params) {
        return this.bi.log(__assign({ evid: 152 }, params));
    };
    /**
    * @typedef {Object} addProGalleryParams
    * @property {GUID} gallery_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - {Editor, App market}
    **/
    /**
     * Name: add_pro_gallery. Evid: 400.
     * Event description: pro gallery was added to the site.
    
     * gallery_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: {Editor, App market}
     * @param {addProGalleryParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.addProGallery = function (params) {
        return this.bi.log(__assign({ evid: 400 }, params));
    };
    /**
    * @typedef {Object} oaGalleryCreateGalleryClickParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: OA Gallery - Create Gallery click. Evid: 548.
     * Event description: user click to create a new Gallery.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {oaGalleryCreateGalleryClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleryCreateGalleryClick = function (params) {
        return this.bi.log(__assign({ evid: 548 }, params));
    };
    /**
    * @typedef {Object} photoAlbumAppOnPublishParams
    * @property {string} albumID - []
    * @property {GUID} albumMsid - []
    * @property {number} numberOfItems - number of images/videos
    * @property {GUID} instance_id - []
    * @property {boolean} isFirst - first time publishing
    * @property {boolean} isPremium - 0 for free, 1 for premium (not in  use)
    * @property {boolean} isPublishDomain - true if successful, false if unsuccessful, null if not connected to domain
    * @property {GUID} migratedFrom - album id of the original album if migrated
    * @property {GUID} biToken - []
    * @property {number} numberOfGalleries - number of galleries
    * @property {string} origin - Editor, BM
    * @property {string} params - json with params
    **/
    /**
     * Name: PhotoAlbum.App.onPublish. Evid: 214.
     * Event description: A publish event in Photo album 2.0 (client).
    
     * albumID - Type: string. Desc: []
     *
     * albumMsid - Type: guid. Desc: []
     *
     * numberOfItems - Type: numeric. Desc: number of images/videos
     *
     * instance_id - Type: guid. Desc: []
     *
     * isFirst - Type: bool. Desc: first time publishing
     *
     * isPremium - Type: bool. Desc: 0 for free, 1 for premium (not in  use)
     *
     * isPublishDomain - Type: bool. Desc: true if successful, false if unsuccessful, null if not connected to domain
     *
     * migratedFrom - Type: guid. Desc: album id of the original album if migrated
     *
     * biToken - Type: guid. Desc: []
     *
     * numberOfGalleries - Type: numeric. Desc: number of galleries
     *
     * origin - Type: string. Desc: Editor, BM
     *
     * params - Type: string. Desc: json with params
     * @param {photoAlbumAppOnPublishParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumAppOnPublish = function (params) {
        return this.bi.log(__assign({ evid: 214 }, params));
    };
    /**
    * @typedef {Object} clickNavigationButtonInAdiSettingsParams
    * @property {string} buttonName - exit/question mark/back
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    * @property {string} origin - screen name in settings
    **/
    /**
     * Name: Click navigation button in ADI settings. Evid: 254.
     * Event description: Click navigation button in ADI settings.
    
     * buttonName - Type: string. Desc: exit/question mark/back
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * origin - Type: string. Desc: screen name in settings
     * @param {clickNavigationButtonInAdiSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickNavigationButtonInAdiSettings = function (params) {
        return this.bi.log(__assign({ evid: 254 }, params));
    };
    /**
    * @typedef {Object} paSettingsViewMainParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: PA Settings - View Main. Evid: 239.
     * Event description: Settings main tab opened (created as exposure for test).
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {paSettingsViewMainParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paSettingsViewMain = function (params) {
        return this.bi.log(__assign({ evid: 239 }, params));
    };
    /**
    * @typedef {Object} cartSettingsParams
    * @property {string} control_name - null
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    * @property {string} value - null
    **/
    /**
     * Name: cart-->settings. Evid: 708.
     * Event description: change icon settings.
    
     * control_name - Type: string.
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     *
     * value - Type: string.
     * @param {cartSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.cartSettings = function (params) {
        return this.bi.log(__assign({ evid: 708 }, params));
    };
    /**
    * @typedef {Object} hoverParams
    * @property {string} category - {Image title, Description, Alt text}
    * @property {GUID} gallery_id - null
    * @property {GUID} instance_id - .
    * @property {GUID} biToken - .
    * @property {string} screenName - null
    * @property {string} value - null
    **/
    /**
     * Name: Hover. Evid: 283.
     * Event description: Hover.
    
     * category - Type: string. Desc: {Image title, Description, Alt text}
     *
     * gallery_id - Type: guid.
     *
     * instance_id - Type: guid. Desc: .
     *
     * biToken - Type: guid. Desc: .
     *
     * screenName - Type: string.
     *
     * value - Type: string.
     * @param {hoverParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.hover = function (params) {
        return this.bi.log(__assign({ evid: 283 }, params));
    };
    /**
    * @typedef {Object} clickEditAlbumsVisibilityParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    * @property {string} origin - origin in settings
    **/
    /**
     * Name: Click edit albums visibility. Evid: 251.
     * Event description: Click edit albums visibility  button in ADI settings.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * origin - Type: string. Desc: origin in settings
     * @param {clickEditAlbumsVisibilityParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickEditAlbumsVisibility = function (params) {
        return this.bi.log(__assign({ evid: 251 }, params));
    };
    /**
    * @typedef {Object} changeToggleInAlbumsVisibilityParams
    * @property {string} albumID - album that was changed
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    * @property {string} value - true/false
    **/
    /**
     * Name: Change toggle in albums visibility. Evid: 252.
     * Event description: when a toggle is changed in the albums visibility list.
    
     * albumID - Type: string. Desc: album that was changed
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * value - Type: string. Desc: true/false
     * @param {changeToggleInAlbumsVisibilityParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.changeToggleInAlbumsVisibility = function (params) {
        return this.bi.log(__assign({ evid: 252 }, params));
    };
    /**
    * @typedef {Object} photoAlbumsClickOnSearchParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - .
    * @property {string} origin - null
    **/
    /**
     * Name: PhotoAlbums - Click On Search. Evid: 241.
    
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: .
     *
     * origin - Type: string.
     * @param {photoAlbumsClickOnSearchParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumsClickOnSearch = function (params) {
        return this.bi.log(__assign({ evid: 241 }, params));
    };
    /**
    * @typedef {Object} oaPhotoAlbumShareParams
    * @property {GUID} album_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} share_type - Default value "NONE" for osType:"android"
    * @property {boolean} success - Default value is "true" for osType:"android"
    **/
    /**
     * Name: OA Photo Album - Share. Evid: 539.
     * Event description: user clicks to share the album.
    
     * album_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * share_type - Type: string. Desc: Default value "NONE" for osType:"android"
     *
     * success - Type: bool. Desc: Default value is "true" for osType:"android"
     * @param {oaPhotoAlbumShareParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaPhotoAlbumShare = function (params) {
        return this.bi.log(__assign({ evid: 539 }, params));
    };
    /**
    * @typedef {Object} proGallerySettingsNavigationParams
    * @property {string} category - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - page name
    * @property {string} subcategory - []
    * @property {boolean} titleOrDescriptionAreChecked - true if one between title_or_description are enabled
    **/
    /**
     * Name: Pro gallery--> Settings navigation. Evid: 411.
     * Event description: navigation between pro gallery settings navigation.
    
     * category - Type: string. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: page name
     *
     * subcategory - Type: string. Desc: []
     *
     * titleOrDescriptionAreChecked - Type: bool. Desc: true if one between title_or_description are enabled
     * @param {proGallerySettingsNavigationParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.proGallerySettingsNavigation = function (params) {
        return this.bi.log(__assign({ evid: 411 }, params));
    };
    /**
    * @typedef {Object} buttonClickInAlbumSettingsParams
    * @property {string} albumID - album_id
    * @property {string} buttonName - save / cancel
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} params - all the params in the save json type
    **/
    /**
     * Name: Button Click In Album Settings. Evid: 256.
     * Event description: when user click on the album setting save or cancel.
    
     * albumID - Type: string. Desc: album_id
     *
     * buttonName - Type: string. Desc: save / cancel
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * params - Type: string. Desc: all the params in the save json type
     * @param {buttonClickInAlbumSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.buttonClickInAlbumSettings = function (params) {
        return this.bi.log(__assign({ evid: 256 }, params));
    };
    /**
    * @typedef {Object} clickLearnMoreInProofingBoParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Click Learn More In Proofing BO. Evid: 263.
     * Event description: When user click in proofing BO learn more.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {clickLearnMoreInProofingBoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickLearnMoreInProofingBo = function (params) {
        return this.bi.log(__assign({ evid: 263 }, params));
    };
    /**
    * @typedef {Object} deleteAlbumParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    **/
    /**
     * Name: delete_album. Evid: 104.
     * Event description: delete_album.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     * @param {deleteAlbumParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.deleteAlbum = function (params) {
        return this.bi.log(__assign({ evid: 104 }, params));
    };
    /**
    * @typedef {Object} manageMediaSetParams
    * @property {string} category - {Image title, Description, Link, Focal point, Importance, Location, EXIF Info, Camera, Lens, Foacl length, Shutter Speed, Aperture, ISO, Date Taken}
    * @property {GUID} gallery_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} value - {}
    **/
    /**
     * Name: manage_media_set. Evid: 404.
     * Event description: manage media change settings.
    
     * category - Type: string. Desc: {Image title, Description, Link, Focal point, Importance, Location, EXIF Info, Camera, Lens, Foacl length, Shutter Speed, Aperture, ISO, Date Taken}
     *
     * gallery_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * value - Type: string. Desc: {}
     * @param {manageMediaSetParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageMediaSet = function (params) {
        return this.bi.log(__assign({ evid: 404 }, params));
    };
    /**
    * @typedef {Object} oaArtStoreSearchOrderParams
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - null
    * @property {GUID} providerId - []
    * @property {string} store_type - []
    **/
    /**
     * Name: OA Art Store - Search order. Evid: 543.
     * Event description: users searches for an order in art store (OA).
    
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid.
     *
     * providerId - Type: guid. Desc: []
     *
     * store_type - Type: string. Desc: []
     * @param {oaArtStoreSearchOrderParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaArtStoreSearchOrder = function (params) {
        return this.bi.log(__assign({ evid: 543 }, params));
    };
    /**
    * @typedef {Object} oaManageMediaAddItemParams
    * @property {string} app_id - []
    * @property {number} numberOfItems - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} source - []
    * @property {string} stage - click (on add item icon), source, choose (item), upload (successful)
    **/
    /**
     * Name: OA Manage media - Add item. Evid: 534.
     * Event description: user click to replace item in manage media.
    
     * app_id - Type: string. Desc: []
     *
     * numberOfItems - Type: numeric. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: []
     *
     * stage - Type: string. Desc: click (on add item icon), source, choose (item), upload (successful)
     * @param {oaManageMediaAddItemParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageMediaAddItem = function (params) {
        return this.bi.log(__assign({ evid: 534 }, params));
    };
    /**
    * @typedef {Object} expandSettingsParams
    * @property {string} control_name - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - photo/pro/store
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    * @property {string} value - null
    **/
    /**
     * Name: expand-->settings. Evid: 703.
     * Event description: change expand mode settings.
    
     * control_name - Type: string.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: photo/pro/store
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     *
     * value - Type: string.
     * @param {expandSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.expandSettings = function (params) {
        return this.bi.log(__assign({ evid: 703 }, params));
    };
    /**
    * @typedef {Object} photoAlbumClickOnAddYourBusinessNameParams
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: photo album-->click on Add your business name. Evid: 205.
     * Event description: click on Add your business name.
    
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {photoAlbumClickOnAddYourBusinessNameParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumClickOnAddYourBusinessName = function (params) {
        return this.bi.log(__assign({ evid: 205 }, params));
    };
    /**
    * @typedef {Object} clickReorderInManualSortingParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    **/
    /**
     * Name: Click reorder in manual sorting. Evid: 250.
     * Event description: Click reorder button when choosing manual sorting in the ADI settings.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     * @param {clickReorderInManualSortingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickReorderInManualSorting = function (params) {
        return this.bi.log(__assign({ evid: 250 }, params));
    };
    /**
    * @typedef {Object} oaPhotoAlbumSaveSettingsParams
    * @property {string} category - name of the tab
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} params - json containing what was saved and the value
    **/
    /**
     * Name: OA Photo Album - Save settings. Evid: 537.
     * Event description: a user clicks on save in Photo album settings in OA.
    
     * category - Type: string. Desc: name of the tab
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * params - Type: string. Desc: json containing what was saved and the value
     * @param {oaPhotoAlbumSaveSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaPhotoAlbumSaveSettings = function (params) {
        return this.bi.log(__assign({ evid: 537 }, params));
    };
    /**
    * @typedef {Object} photoAlbumStoreToggleWatermarkParams
    * @property {GUID} albumID - album id
    * @property {GUID} instance_id - app instance_id
    * @property {GUID} biToken - null
    * @property {GUID} parentmetasite - msid of the parent site
    * @property {string} screenName - screen name
    * @property {string} value - on/off
    **/
    /**
     * Name: Photo Album store-->toggle watermark. Evid: 186.
     * Event description: toggle watermark on/off.
    
     * albumID - Type: guid. Desc: album id
     *
     * instance_id - Type: guid. Desc: app instance_id
     *
     * biToken - Type: guid.
     *
     * parentmetasite - Type: guid. Desc: msid of the parent site
     *
     * screenName - Type: string. Desc: screen name
     *
     * value - Type: string. Desc: on/off
     * @param {photoAlbumStoreToggleWatermarkParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumStoreToggleWatermark = function (params) {
        return this.bi.log(__assign({ evid: 186 }, params));
    };
    /**
    * @typedef {Object} openPhotoAlbumsSettingsAdiParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Open Photo Albums Settings ADI. Evid: 245.
     * Event description: when settings are opened in the ADI.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid.
     * @param {openPhotoAlbumsSettingsAdiParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openPhotoAlbumsSettingsAdi = function (params) {
        return this.bi.log(__assign({ evid: 245 }, params));
    };
    /**
    * @typedef {Object} refreshSeoParamsEndedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: refresh_SEO_params_ended. Evid: 160.
     * Event description: refresh_SEO_params_ended.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {refreshSeoParamsEndedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.refreshSeoParamsEnded = function (params) {
        return this.bi.log(__assign({ evid: 160 }, params));
    };
    /**
    * @typedef {Object} licenseLicenseEditParams
    * @property {string} action - edit/duplicate/delete
    * @property {string} app_id - null
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: license-->license edit. Evid: 715.
     * Event description: edit license.
    
     * action - Type: string. Desc: edit/duplicate/delete
     *
     * app_id - Type: string.
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {licenseLicenseEditParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseLicenseEdit = function (params) {
        return this.bi.log(__assign({ evid: 715 }, params));
    };
    /**
    * @typedef {Object} wizardUploadTriggerParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} selection - {button, drag}
    **/
    /**
     * Name: wizard_upload_trigger. Evid: 129.
     * Event description: wizard_upload_trigger.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * selection - Type: string. Desc: {button, drag}
     * @param {wizardUploadTriggerParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardUploadTrigger = function (params) {
        return this.bi.log(__assign({ evid: 129 }, params));
    };
    /**
    * @typedef {Object} photoAlbumPageOnLoadParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Editor, BM, custom origin
    * @property {string} screenName - []
    **/
    /**
     * Name: PhotoAlbum.Page.onLoad. Evid: 210.
     * Event description: A page loads in Photo album 2.0.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Editor, BM, custom origin
     *
     * screenName - Type: string. Desc: []
     * @param {photoAlbumPageOnLoadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumPageOnLoad = function (params) {
        return this.bi.log(__assign({ evid: 210 }, params));
    };
    /**
    * @typedef {Object} clickSaveCollectionParams
    * @property {string} albumID - album_id
    * @property {number} amountOfItems - the number of items in the collection include the new items
    * @property {number} amountOfItemsSelected - the number of items that add to the collection
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member=client)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click Save Collection. Evid: 232.
     * Event description: when save collection media.
    
     * albumID - Type: string. Desc: album_id
     *
     * amountOfItems - Type: numeric. Desc: the number of items in the collection include the new items
     *
     * amountOfItemsSelected - Type: numeric. Desc: the number of items that add to the collection
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member=client)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickSaveCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickSaveCollection = function (params) {
        return this.bi.log(__assign({ evid: 232 }, params));
    };
    /**
    * @typedef {Object} editorResizeImagesViewParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} selection - {small,medium,large}
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_resize_images_view. Evid: 136.
     * Event description: editor_resize_images_view.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * selection - Type: string. Desc: {small,medium,large}
     *
     * set_id - Type: string. Desc: -
     * @param {editorResizeImagesViewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorResizeImagesView = function (params) {
        return this.bi.log(__assign({ evid: 136 }, params));
    };
    /**
    * @typedef {Object} photoAlbumChangeTextParams
    * @property {string} field - field name
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} value - value
    **/
    /**
     * Name: photo album-->change text. Evid: 203.
     * Event description: change title or description.
    
     * field - Type: string. Desc: field name
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * value - Type: string. Desc: value
     * @param {photoAlbumChangeTextParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumChangeText = function (params) {
        return this.bi.log(__assign({ evid: 203 }, params));
    };
    /**
    * @typedef {Object} oaGalleriesSettingsClickParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA galleries settings click. Evid: 525.
     * Event description: User clicks on gallery settings in the OA Pro Gallery manage menu.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {oaGalleriesSettingsClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleriesSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 525 }, params));
    };
    /**
    * @typedef {Object} supportQuestionClickParams
    * @property {GUID} instance_id - null
    * @property {string} link_name - the link the user clicks on
    * @property {GUID} biToken - null
    **/
    /**
     * Name: support question click. Evid: 901.
     * Event description: when the user clicks on one of the links to go see answer for the question.
    
     * instance_id - Type: guid.
     *
     * link_name - Type: string. Desc: the link the user clicks on
     *
     * biToken - Type: guid.
     * @param {supportQuestionClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.supportQuestionClick = function (params) {
        return this.bi.log(__assign({ evid: 901 }, params));
    };
    /**
    * @typedef {Object} openMemberActionMenuParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Open Member Action Menu. Evid: 223.
     * Event description: arrived when the user click on open member action menu.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {openMemberActionMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openMemberActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 223 }, params));
    };
    /**
    * @typedef {Object} photoAlbumStoreToggleActiveParams
    * @property {GUID} albumID - album id
    * @property {GUID} instance_id - app instance_id
    * @property {GUID} biToken - null
    * @property {GUID} parentmetasite - msid of the parent site
    * @property {string} screenName - screen name
    * @property {string} value - on/off
    **/
    /**
     * Name: Photo Album store -->toggle active. Evid: 185.
     * Event description: toggle store is active on/off.
    
     * albumID - Type: guid. Desc: album id
     *
     * instance_id - Type: guid. Desc: app instance_id
     *
     * biToken - Type: guid.
     *
     * parentmetasite - Type: guid. Desc: msid of the parent site
     *
     * screenName - Type: string. Desc: screen name
     *
     * value - Type: string. Desc: on/off
     * @param {photoAlbumStoreToggleActiveParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumStoreToggleActive = function (params) {
        return this.bi.log(__assign({ evid: 185 }, params));
    };
    /**
    * @typedef {Object} oaItemShareParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} media_type - []
    * @property {GUID} biToken -
    * @property {string} share_type - Default value "NONE" for osType:"android"
    * @property {boolean} success - Default value is "true" for osType:"android"
    **/
    /**
     * Name: OA item share. Evid: 518.
     * Event description: user clicks to share the gallery media item expend mode web page.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * media_type - Type: string. Desc: []
     *
     * biToken - Type: guid.
     *
     * share_type - Type: string. Desc: Default value "NONE" for osType:"android"
     *
     * success - Type: bool. Desc: Default value is "true" for osType:"android"
     * @param {oaItemShareParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaItemShare = function (params) {
        return this.bi.log(__assign({ evid: 518 }, params));
    };
    /**
    * @typedef {Object} copyOfAlbumsListViewParams
    * @property {GUID} app_site_id - -
    * @property {string} button - dfasd
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_albums - number of albums
    **/
    /**
     * Name: Copy of albums_list_view. Evid: 175.
     * Event description: albums_list_view- page appear.
    
     * app_site_id - Type: guid. Desc: -
     *
     * button - Type: string. Desc: dfasd
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_albums - Type: numeric. Desc: number of albums
     * @param {copyOfAlbumsListViewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.copyOfAlbumsListView = function (params) {
        return this.bi.log(__assign({ evid: 175 }, params));
    };
    /**
    * @typedef {Object} downloadFilesFromCollectionParams
    * @property {string} albumID - album_id
    * @property {string} button_name - action name
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - role in the album (owner/member)
    * @property {string} source - bzm/etc.....
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Download Files From Collection. Evid: 218.
     * Event description: when user choose the download way.
    
     * albumID - Type: string. Desc: album_id
     *
     * button_name - Type: string. Desc: action name
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: role in the album (owner/member)
     *
     * source - Type: string. Desc: bzm/etc.....
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {downloadFilesFromCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.downloadFilesFromCollection = function (params) {
        return this.bi.log(__assign({ evid: 218 }, params));
    };
    /**
    * @typedef {Object} proGalleryLoadUsersParams
    * @property {string} endpoint - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - null
    * @property {number} items_count - null
    * @property {number} loading_time - null
    * @property {GUID} biToken - null
    * @property {string} phase - null
    **/
    /**
     * Name: pro gallery load-->users. Evid: 177.
     * Event description: pro gallery end point users client.
    
     * endpoint - Type: string.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid.
     *
     * items_count - Type: numeric.
     *
     * loading_time - Type: numeric.
     *
     * biToken - Type: guid.
     *
     * phase - Type: string.
     * @param {proGalleryLoadUsersParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.proGalleryLoadUsers = function (params) {
        return this.bi.log(__assign({ evid: 177 }, params));
    };
    /**
    * @typedef {Object} photoAlbumRemoveMediaParams
    * @property {number} count - num of photos removed
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} type - []
    **/
    /**
     * Name: photo album-->remove_media. Evid: 202.
     * Event description: Remove_media from photo album.
    
     * count - Type: numeric. Desc: num of photos removed
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * type - Type: string. Desc: []
     * @param {photoAlbumRemoveMediaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumRemoveMedia = function (params) {
        return this.bi.log(__assign({ evid: 202 }, params));
    };
    /**
    * @typedef {Object} artStorePerformanceParams
    * @property {number} client_rt - client rendering time
    * @property {string} end_point - shop, checkout, configuration, manage, purchaseEnd, cart
    * @property {GUID} instance_id - []
    * @property {boolean} is_optimization_on - true/false
    * @property {GUID} biToken - []
    * @property {number} server_rt - server rendering time
    **/
    /**
     * Name: art store -->performance. Evid: 731.
     * Event description: performance testing event.
    
     * client_rt - Type: numeric. Desc: client rendering time
     *
     * end_point - Type: string. Desc: shop, checkout, configuration, manage, purchaseEnd, cart
     *
     * instance_id - Type: guid. Desc: []
     *
     * is_optimization_on - Type: bool. Desc: true/false
     *
     * biToken - Type: guid. Desc: []
     *
     * server_rt - Type: numeric. Desc: server rendering time
     * @param {artStorePerformanceParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStorePerformance = function (params) {
        return this.bi.log(__assign({ evid: 731 }, params));
    };
    /**
    * @typedef {Object} oaDownloadMediaParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} media_type - []
    * @property {GUID} biToken - null
    * @property {boolean} success - []
    **/
    /**
     * Name: OA download media. Evid: 517.
     * Event description: user clicks to download a media in a gallery.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * media_type - Type: string. Desc: []
     *
     * biToken - Type: guid.
     *
     * success - Type: bool. Desc: []
     * @param {oaDownloadMediaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaDownloadMedia = function (params) {
        return this.bi.log(__assign({ evid: 517 }, params));
    };
    /**
    * @typedef {Object} clickOnActionInMemberMenuParams
    * @property {string} albumID - album_id
    * @property {string} button_name - the name of the action
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click On Action In Member Menu. Evid: 224.
     * Event description: arrived when the user chose an action from the menu.
    
     * albumID - Type: string. Desc: album_id
     *
     * button_name - Type: string. Desc: the name of the action
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnActionInMemberMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnActionInMemberMenu = function (params) {
        return this.bi.log(__assign({ evid: 224 }, params));
    };
    /**
    * @typedef {Object} startUploadToMediaBatchParams
    * @property {string} albumID - .
    * @property {number} batchCount - How many files in the batch
    * @property {string} batchId - .
    * @property {number} batchSize - Size in bits
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - .
    * @property {string} setID - .
    * @property {string} type - image/folder
    **/
    /**
     * Name: Start Upload To Media - Batch. Evid: 192.
     * Event description: Indicates the beginning of a batch upload.
    
     * albumID - Type: string. Desc: .
     *
     * batchCount - Type: numeric. Desc: How many files in the batch
     *
     * batchId - Type: string. Desc: .
     *
     * batchSize - Type: numeric. Desc: Size in bits
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: .
     *
     * setID - Type: string. Desc: .
     *
     * type - Type: string. Desc: image/folder
     * @param {startUploadToMediaBatchParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.startUploadToMediaBatch = function (params) {
        return this.bi.log(__assign({ evid: 192 }, params));
    };
    /**
    * @typedef {Object} openItemCollectionActionMenuParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {string} item_id - id of the chosen item
    * @property {GUID} biToken - null
    * @property {string} origin - bzm/member area
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Open Item Collection Action Menu. Evid: 220.
     * Event description: when user open item menu in the collection.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * item_id - Type: string. Desc: id of the chosen item
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: bzm/member area
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {openItemCollectionActionMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openItemCollectionActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 220 }, params));
    };
    /**
    * @typedef {Object} publishInSantaEndedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} metasite_id - -
    **/
    /**
     * Name: publish_in_santa_ended. Evid: 164.
     * Event description: publish_in_santa_ended.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * metasite_id - Type: guid. Desc: -
     * @param {publishInSantaEndedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.publishInSantaEnded = function (params) {
        return this.bi.log(__assign({ evid: 164 }, params));
    };
    /**
    * @typedef {Object} siteActionParams
    * @property {string} action_name - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: site_action. Evid: 149.
     * Event description: site_action.
    
     * action_name - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {siteActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.siteAction = function (params) {
        return this.bi.log(__assign({ evid: 149 }, params));
    };
    /**
    * @typedef {Object} oaPhotoAlbumViewAlbumParams
    * @property {GUID} album_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - member or manage
    **/
    /**
     * Name: OA Photo Album - View Album. Evid: 535.
     * Event description: user clicks to view one of the albums in the album list in OA.
    
     * album_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: member or manage
     * @param {oaPhotoAlbumViewAlbumParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaPhotoAlbumViewAlbum = function (params) {
        return this.bi.log(__assign({ evid: 535 }, params));
    };
    /**
    * @typedef {Object} publishErrorParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {string} error - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: publish_error. Evid: 159.
     * Event description: publish_error.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * error - Type: string. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {publishErrorParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.publishError = function (params) {
        return this.bi.log(__assign({ evid: 159 }, params));
    };
    /**
    * @typedef {Object} oaCloseGalleriesSettingsParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - "x" or "save"
    **/
    /**
     * Name: OA close galleries settings. Evid: 528.
     * Event description: user clicks on save or 'x' in the settings of the manage gallery in OA.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: "x" or "save"
     * @param {oaCloseGalleriesSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaCloseGalleriesSettings = function (params) {
        return this.bi.log(__assign({ evid: 528 }, params));
    };
    /**
    * @typedef {Object} topMenuParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selection - {help,feedback}
    **/
    /**
     * Name: top_menu. Evid: 101.
     * Event description: top_menu selection in albums_list page.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {help,feedback}
     * @param {topMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.topMenu = function (params) {
        return this.bi.log(__assign({ evid: 101 }, params));
    };
    /**
    * @typedef {Object} chooseAlbumAppearanceOptionParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    * @property {string} value - new window/popup
    **/
    /**
     * Name: Choose album appearance option. Evid: 247.
     * Event description: choose how album will appear when opens in ADI from dropdown list.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * value - Type: string. Desc: new window/popup
     * @param {chooseAlbumAppearanceOptionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.chooseAlbumAppearanceOption = function (params) {
        return this.bi.log(__assign({ evid: 247 }, params));
    };
    /**
    * @typedef {Object} oaPhotoAlbumAlbumActionParams
    * @property {GUID} album_id - []
    * @property {string} category - what was clicked
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} tab - tab name
    **/
    /**
     * Name: OA Photo Album - Album Action. Evid: 536.
     * Event description: user performs an action from the menu in manage album in OA.
    
     * album_id - Type: guid. Desc: []
     *
     * category - Type: string. Desc: what was clicked
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * tab - Type: string. Desc: tab name
     * @param {oaPhotoAlbumAlbumActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaPhotoAlbumAlbumAction = function (params) {
        return this.bi.log(__assign({ evid: 536 }, params));
    };
    /**
    * @typedef {Object} albumActionsUpdateEndedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: album_actions_update_ended. Evid: 169.
     * Event description: album_actions_update_ended.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {albumActionsUpdateEndedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.albumActionsUpdateEnded = function (params) {
        return this.bi.log(__assign({ evid: 169 }, params));
    };
    /**
    * @typedef {Object} licenseSaveParams
    * @property {string} app_id - null
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - gallery_id
    **/
    /**
     * Name: license-->save. Evid: 721.
     * Event description: save license changes.
    
     * app_id - Type: string.
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid. Desc: gallery_id
     * @param {licenseSaveParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseSave = function (params) {
        return this.bi.log(__assign({ evid: 721 }, params));
    };
    /**
    * @typedef {Object} editorPreviewImagesParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {number} precentage - -
    **/
    /**
     * Name: editor_preview_images. Evid: 115.
     * Event description: editor_preview_images.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * precentage - Type: numeric. Desc: -
     * @param {editorPreviewImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorPreviewImages = function (params) {
        return this.bi.log(__assign({ evid: 115 }, params));
    };
    /**
    * @typedef {Object} oaSaveSettingsParams
    * @property {string} app_id - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} params - [array with current situation]
    * @property {string} updated - [array with updated fields]
    **/
    /**
     * Name: OA save settings. Evid: 524.
     * Event description: user clicks on save in the settings screen (now only rename).
    
     * app_id - Type: string. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * params - Type: string. Desc: [array with current situation]
     *
     * updated - Type: string. Desc: [array with updated fields]
     * @param {oaSaveSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaSaveSettings = function (params) {
        return this.bi.log(__assign({ evid: 524 }, params));
    };
    /**
    * @typedef {Object} photoAlbumsClickOnSortParams
    * @property {GUID} instance_id - .
    * @property {GUID} biToken - .
    * @property {string} origin - Editor, BM, custom origin
    * @property {string} params - the sort way ( a- z , z-a)
    **/
    /**
     * Name: PhotoAlbums - Click On Sort. Evid: 242.
     * Event description: arrive when the user click on the search sort in the album list.
    
     * instance_id - Type: guid. Desc: .
     *
     * biToken - Type: guid. Desc: .
     *
     * origin - Type: string. Desc: Editor, BM, custom origin
     *
     * params - Type: string. Desc: the sort way ( a- z , z-a)
     * @param {photoAlbumsClickOnSortParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumsClickOnSort = function (params) {
        return this.bi.log(__assign({ evid: 242 }, params));
    };
    /**
    * @typedef {Object} artStoreStartNowParams
    * @property {string} app_id - []
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: art store --> start now. Evid: 729.
     * Event description: click on start now.
    
     * app_id - Type: string. Desc: []
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {artStoreStartNowParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStoreStartNow = function (params) {
        return this.bi.log(__assign({ evid: 729 }, params));
    };
    /**
    * @typedef {Object} oaManageMediaClickOnItemParams
    * @property {string} app_id - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {number} media_index - []
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA Manage media - Click on item. Evid: 530.
     * Event description: user clicks on item in manage media.
    
     * app_id - Type: string. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * media_index - Type: numeric. Desc: []
     *
     * biToken - Type: guid.
     * @param {oaManageMediaClickOnItemParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageMediaClickOnItem = function (params) {
        return this.bi.log(__assign({ evid: 530 }, params));
    };
    /**
    * @typedef {Object} singleImageSettingsApplyParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} itemId - []
    * @property {GUID} biToken - null
    * @property {string} params - json with toggles (adjust image quality and image sharpening)
    **/
    /**
     * Name: Single image settings - Apply. Evid: 421.
     * Event description: User clicks on Apply when in Single Image settings in the organize media.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * itemId - Type: string. Desc: []
     *
     * biToken - Type: guid.
     *
     * params - Type: string. Desc: json with toggles (adjust image quality and image sharpening)
     * @param {singleImageSettingsApplyParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.singleImageSettingsApply = function (params) {
        return this.bi.log(__assign({ evid: 421 }, params));
    };
    /**
    * @typedef {Object} settingsLoadParams
    * @property {GUID} instance_id - null
    * @property {GUID} msid - {guid}
    * @property {GUID} bi_token - bi_token
    * @property {GUID} biToken - null
    **/
    /**
     * Name: settings_load. Evid: 174.
     * Event description: new settings dialog loading event.
    
     * instance_id - Type: guid.
     *
     * msid - Type: guid. Desc: {guid}
     *
     * bi_token - Type: guid. Desc: bi_token
     *
     * biToken - Type: guid.
     * @param {settingsLoadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsLoad = function (params) {
        return this.bi.log(__assign({ evid: 174 }, params));
    };
    /**
    * @typedef {Object} photoStatsTipClickParams
    * @property {string} ctaId - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Photo stats>Tip click. Evid: 179.
     * Event description: click CTA on photo album stats.
    
     * ctaId - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {photoStatsTipClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoStatsTipClick = function (params) {
        return this.bi.log(__assign({ evid: 179 }, params));
    };
    /**
    * @typedef {Object} navigationInItemPreviewCollectionParams
    * @property {string} albumID - album_id
    * @property {string} category - store/discussions
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {string} itemId - id of the chosen item
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Navigation In Item Preview Collection. Evid: 231.
     * Event description: click on navigation in item preview.
    
     * albumID - Type: string. Desc: album_id
     *
     * category - Type: string. Desc: store/discussions
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * itemId - Type: string. Desc: id of the chosen item
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {navigationInItemPreviewCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.navigationInItemPreviewCollection = function (params) {
        return this.bi.log(__assign({ evid: 231 }, params));
    };
    /**
    * @typedef {Object} editorClearAllImagesParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_clear_all_images. Evid: 138.
     * Event description: editor_clear_all_images.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * set_id - Type: string. Desc: -
     * @param {editorClearAllImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorClearAllImages = function (params) {
        return this.bi.log(__assign({ evid: 138 }, params));
    };
    /**
    * @typedef {Object} click3DotsInListProofingParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for coellection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click 3 Dots in List Proofing. Evid: 271.
     * Event description: when user click on the 3 dots menu in proofing list.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for coellection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {click3DotsInListProofingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.click3DotsInListProofing = function (params) {
        return this.bi.log(__assign({ evid: 271 }, params));
    };
    /**
    * @typedef {Object} publishInSantaFailedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {string} error_code - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} metasite_id - -
    **/
    /**
     * Name: publish_in_santa_failed. Evid: 167.
     * Event description: publish_in_santa_failed.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * error_code - Type: string. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * metasite_id - Type: guid. Desc: -
     * @param {publishInSantaFailedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.publishInSantaFailed = function (params) {
        return this.bi.log(__assign({ evid: 167 }, params));
    };
    /**
    * @typedef {Object} photoAlbumsFilterClickParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - .
    * @property {string} origin - Editor, BM, custom origin
    * @property {string} value - filter value
    **/
    /**
     * Name: PhotoAlbums - Filter Click. Evid: 244.
    
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: .
     *
     * origin - Type: string. Desc: Editor, BM, custom origin
     *
     * value - Type: string. Desc: filter value
     * @param {photoAlbumsFilterClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumsFilterClick = function (params) {
        return this.bi.log(__assign({ evid: 244 }, params));
    };
    /**
    * @typedef {Object} previewItemInCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {string} itemId - id of the chosen item
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} source - preview/selected_media/discussions
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Preview Item In Collection. Evid: 230.
     * Event description: Arrived when collection member click preview item.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * itemId - Type: string. Desc: id of the chosen item
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * source - Type: string. Desc: preview/selected_media/discussions
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {previewItemInCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.previewItemInCollection = function (params) {
        return this.bi.log(__assign({ evid: 230 }, params));
    };
    /**
    * @typedef {Object} licenseUploadLicenseParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: license-->upload license. Evid: 713.
     * Event description: upload external license.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {licenseUploadLicenseParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseUploadLicense = function (params) {
        return this.bi.log(__assign({ evid: 713 }, params));
    };
    /**
    * @typedef {Object} oaOpenEditGalleriesParams
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: OA Open edit galleries. Evid: 545.
    
    
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {oaOpenEditGalleriesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaOpenEditGalleries = function (params) {
        return this.bi.log(__assign({ evid: 545 }, params));
    };
    /**
    * @typedef {Object} oaManageGalleryActionParams
    * @property {string} category - what field was clicked,
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA manage gallery action. Evid: 523.
     * Event description: user clicks on one of the actions from the menu in manage gallery.
    
     * category - Type: string. Desc: what field was clicked,
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {oaManageGalleryActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageGalleryAction = function (params) {
        return this.bi.log(__assign({ evid: 523 }, params));
    };
    /**
    * @typedef {Object} oaManageMediaEditItemSaveParams
    * @property {string} app_id - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} params - []
    **/
    /**
     * Name: OA Manage media - Edit Item save. Evid: 532.
     * Event description: user saves the replace of the item in manage media.
    
     * app_id - Type: string. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * params - Type: string. Desc: []
     * @param {oaManageMediaEditItemSaveParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageMediaEditItemSave = function (params) {
        return this.bi.log(__assign({ evid: 532 }, params));
    };
    /**
    * @typedef {Object} manageMediaClickParams
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - photo/pro/store
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    **/
    /**
     * Name: manage media click. Evid: 700.
     * Event description: click on manage media.
    
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: photo/pro/store
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     * @param {manageMediaClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageMediaClick = function (params) {
        return this.bi.log(__assign({ evid: 700 }, params));
    };
    /**
    * @typedef {Object} settingsClickCreateAlbumParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Main
    **/
    /**
     * Name: Settings_click_create_album. Evid: 237.
     * Event description: click on create new album button.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Main
     * @param {settingsClickCreateAlbumParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsClickCreateAlbum = function (params) {
        return this.bi.log(__assign({ evid: 237 }, params));
    };
    /**
    * @typedef {Object} editorDetailsEditParams
    * @property {GUID} app_site_id - -
    * @property {string} field - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} new_value - -
    * @property {string} photo_site_id - -
    **/
    /**
     * Name: editor_details_edit. Evid: 125.
     * Event description: editor_details_edit- saved on blur.
    
     * app_site_id - Type: guid. Desc: -
     *
     * field - Type: string. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * new_value - Type: string. Desc: -
     *
     * photo_site_id - Type: string. Desc: -
     * @param {editorDetailsEditParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorDetailsEdit = function (params) {
        return this.bi.log(__assign({ evid: 125 }, params));
    };
    /**
    * @typedef {Object} organizeMediaChangeSettingsParams
    * @property {string} buttonName - null
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Organize Media - Change Settings. Evid: 278.
    
    
     * buttonName - Type: string.
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid.
     * @param {organizeMediaChangeSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.organizeMediaChangeSettings = function (params) {
        return this.bi.log(__assign({ evid: 278 }, params));
    };
    /**
    * @typedef {Object} photoAlbumSettingsOpenParams
    * @property {string} category - manage media/layouts/design/settings/info
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: photo album-->settings-->open. Evid: 200.
     * Event description: open one of the Photo album settings (left buttons) - upon click (and not load).
    
     * category - Type: string. Desc: manage media/layouts/design/settings/info
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {photoAlbumSettingsOpenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumSettingsOpen = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} oaGalleryGalleryCreatedParams
    * @property {string} app_id - []
    * @property {number} count - null
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - []
    * @property {string} media_type - type of media (images, video, mixed)
    * @property {GUID} biToken - []
    * @property {string} params - Json with gallery name and boolean values for Share, Download, Display
    * @property {string} source - device, media manager, camera
    **/
    /**
     * Name: OA Gallery - Gallery created. Evid: 549.
     * Event description: a new Gallery is created.
    
     * app_id - Type: string. Desc: []
     *
     * count - Type: numeric.
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * media_type - Type: string. Desc: type of media (images, video, mixed)
     *
     * biToken - Type: guid. Desc: []
     *
     * params - Type: string. Desc: Json with gallery name and boolean values for Share, Download, Display
     *
     * source - Type: string. Desc: device, media manager, camera
     * @param {oaGalleryGalleryCreatedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleryGalleryCreated = function (params) {
        return this.bi.log(__assign({ evid: 549 }, params));
    };
    /**
    * @typedef {Object} settingsMyAlbumsAlbumVisibleParams
    * @property {string} action - {visible,hidden}
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - {visible_tab,all_tab}
    **/
    /**
     * Name: settings_my_albums_album_visible. Evid: 153.
     * Event description: settings_my_albums_album_visible.
    
     * action - Type: string. Desc: {visible,hidden}
     *
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: {visible_tab,all_tab}
     * @param {settingsMyAlbumsAlbumVisibleParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsMyAlbumsAlbumVisible = function (params) {
        return this.bi.log(__assign({ evid: 153 }, params));
    };
    /**
    * @typedef {Object} mangeMediaUpperPanelOpenParams
    * @property {string} category - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: mange_media_upper_panel_open. Evid: 402.
     * Event description: pro gallery media manage.
    
     * category - Type: string.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {mangeMediaUpperPanelOpenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.mangeMediaUpperPanelOpen = function (params) {
        return this.bi.log(__assign({ evid: 402 }, params));
    };
    /**
    * @typedef {Object} changeAlbumsOrderDisplayParams
    * @property {string} albumID - -
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    * @property {number} valueInt - new sorting place
    **/
    /**
     * Name: Change albums order display. Evid: 253.
     * Event description: Drag album to different order in ADI settings.
    
     * albumID - Type: string. Desc: -
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * valueInt - Type: numeric. Desc: new sorting place
     * @param {changeAlbumsOrderDisplayParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.changeAlbumsOrderDisplay = function (params) {
        return this.bi.log(__assign({ evid: 253 }, params));
    };
    /**
    * @typedef {Object} storeSetUpClickParams
    * @property {string} category - null
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    **/
    /**
     * Name: store set up click. Evid: 702.
     * Event description: click on one of the buttons on Set up your store screen.
    
     * category - Type: string.
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     * @param {storeSetUpClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.storeSetUpClick = function (params) {
        return this.bi.log(__assign({ evid: 702 }, params));
    };
    /**
    * @typedef {Object} editorDownloadPermissionParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {boolean} permission - -
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_download_permission. Evid: 144.
     * Event description: editor_download_permission.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * permission - Type: bool. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {editorDownloadPermissionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorDownloadPermission = function (params) {
        return this.bi.log(__assign({ evid: 144 }, params));
    };
    /**
    * @typedef {Object} oaGalleriesActionMenuPressParams
    * @property {string} category - what field was clicked,
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA Galleries action menu press. Evid: 544.
     * Event description: user clicks on one of the actions from the menu in manage gallery (Photo Store).
    
     * category - Type: string. Desc: what field was clicked,
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {oaGalleriesActionMenuPressParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleriesActionMenuPress = function (params) {
        return this.bi.log(__assign({ evid: 544 }, params));
    };
    /**
    * @typedef {Object} artStoreSaveBusinessInfoParams
    * @property {string} app_id - []
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - orders/licenses/payment/bus info
    * @property {string} providerId - provider id
    **/
    /**
     * Name: art store --> save business info. Evid: 728.
     * Event description: users navigates in dashboard.
    
     * app_id - Type: string. Desc: []
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: orders/licenses/payment/bus info
     *
     * providerId - Type: string. Desc: provider id
     * @param {artStoreSaveBusinessInfoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStoreSaveBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 728 }, params));
    };
    /**
    * @typedef {Object} settingsMyAlbumsAlbumEditParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: settings_my_albums_album_edit. Evid: 154.
     * Event description: settings_my_albums_album_edit.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {settingsMyAlbumsAlbumEditParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsMyAlbumsAlbumEdit = function (params) {
        return this.bi.log(__assign({ evid: 154 }, params));
    };
    /**
    * @typedef {Object} saveInSantaEndedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} metasite_id - -
    * @property {GUID} site_id - -
    **/
    /**
     * Name: save_in_santa_ended. Evid: 162.
     * Event description: save_in_santa_ended.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * metasite_id - Type: guid. Desc: -
     *
     * site_id - Type: guid. Desc: -
     * @param {saveInSantaEndedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.saveInSantaEnded = function (params) {
        return this.bi.log(__assign({ evid: 162 }, params));
    };
    /**
    * @typedef {Object} publishStartParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: publish_start. Evid: 158.
     * Event description: publish_start.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {publishStartParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.publishStart = function (params) {
        return this.bi.log(__assign({ evid: 158 }, params));
    };
    /**
    * @typedef {Object} photoAlbumStoreCompletedSetUpStoreParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - orders/licenses/payment/bus info
    * @property {GUID} providerId - provider id
    **/
    /**
     * Name: Photo Album store --> completed set up store. Evid: 189.
     * Event description: users confirmed photo rights.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: orders/licenses/payment/bus info
     *
     * providerId - Type: guid. Desc: provider id
     * @param {photoAlbumStoreCompletedSetUpStoreParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumStoreCompletedSetUpStore = function (params) {
        return this.bi.log(__assign({ evid: 189 }, params));
    };
    /**
    * @typedef {Object} sortAlbumsOptionsViewedParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    **/
    /**
     * Name: Sort albums options viewed. Evid: 248.
     * Event description: Click on sort albums in ADI settings.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     * @param {sortAlbumsOptionsViewedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.sortAlbumsOptionsViewed = function (params) {
        return this.bi.log(__assign({ evid: 248 }, params));
    };
    /**
    * @typedef {Object} clickOnLearnMoreProofingWizardParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Click On Learn More Proofing Wizard. Evid: 197.
     * Event description: this events fired when the user click on learn more in the wizard.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {clickOnLearnMoreProofingWizardParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnLearnMoreProofingWizard = function (params) {
        return this.bi.log(__assign({ evid: 197 }, params));
    };
    /**
    * @typedef {Object} openDialogParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - {create_new_site,photos,design,details,settings,help,publish}
    **/
    /**
     * Name: open_dialog. Evid: 147.
     * Event description: open_dialog.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: {create_new_site,photos,design,details,settings,help,publish}
     * @param {openDialogParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openDialog = function (params) {
        return this.bi.log(__assign({ evid: 147 }, params));
    };
    /**
    * @typedef {Object} photoAlbumPageActionParams
    * @property {string} action - add/remove
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: photo album-->page action. Evid: 204.
     * Event description: Add/Remove page.
    
     * action - Type: string. Desc: add/remove
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {photoAlbumPageActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumPageAction = function (params) {
        return this.bi.log(__assign({ evid: 204 }, params));
    };
    /**
    * @typedef {Object} editorChangeDesignParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} selection - {party,newborn,weddings1,weddings2,modeling,engagement}
    **/
    /**
     * Name: editor_change_design. Evid: 124.
     * Event description: editor_change_design.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * selection - Type: string. Desc: {party,newborn,weddings1,weddings2,modeling,engagement}
     * @param {editorChangeDesignParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorChangeDesign = function (params) {
        return this.bi.log(__assign({ evid: 124 }, params));
    };
    /**
    * @typedef {Object} wizardStepUploadParams
    * @property {string} albumID - []
    * @property {string} albumVersion - photo album 2.0 or old
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_images - -
    * @property {string} origin - Editor, BM
    **/
    /**
     * Name: wizard_step_upload. Evid: 113.
     * Event description: wizard_step_upload.
    
     * albumID - Type: string. Desc: []
     *
     * albumVersion - Type: string. Desc: photo album 2.0 or old
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_images - Type: numeric. Desc: -
     *
     * origin - Type: string. Desc: Editor, BM
     * @param {wizardStepUploadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardStepUpload = function (params) {
        return this.bi.log(__assign({ evid: 113 }, params));
    };
    /**
    * @typedef {Object} licenseNewLicenseSaveParams
    * @property {string} app_id - []
    * @property {string} description - license description
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - license name
    **/
    /**
     * Name: license-->new license save. Evid: 714.
     * Event description: save new license.
    
     * app_id - Type: string. Desc: []
     *
     * description - Type: string. Desc: license description
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: license name
     * @param {licenseNewLicenseSaveParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseNewLicenseSave = function (params) {
        return this.bi.log(__assign({ evid: 714 }, params));
    };
    /**
    * @typedef {Object} editorLoadingCompleteParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    **/
    /**
     * Name: editor_loading_complete. Evid: 116.
     * Event description: editor_loading_complete.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     * @param {editorLoadingCompleteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorLoadingComplete = function (params) {
        return this.bi.log(__assign({ evid: 116 }, params));
    };
    /**
    * @typedef {Object} clickOnTransferParams
    * @property {string} album_id - album id
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - from which button the user clicked (publish pop up, etc..)
    **/
    /**
     * Name: Click on transfer. Evid: 172.
     * Event description: user clicked ontransfer button.
    
     * album_id - Type: string. Desc: album id
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: from which button the user clicked (publish pop up, etc..)
     * @param {clickOnTransferParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnTransfer = function (params) {
        return this.bi.log(__assign({ evid: 172 }, params));
    };
    /**
    * @typedef {Object} oaManageMediaOrderMediaParams
    * @property {string} app_id - null
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} newOrderIndex - []
    * @property {number} oldOrderIndex - []
    **/
    /**
     * Name: OA Manage media - Order media. Evid: 529.
     * Event description: user reorders media in manage media.
    
     * app_id - Type: string.
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * newOrderIndex - Type: numeric. Desc: []
     *
     * oldOrderIndex - Type: numeric. Desc: []
     * @param {oaManageMediaOrderMediaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaManageMediaOrderMedia = function (params) {
        return this.bi.log(__assign({ evid: 529 }, params));
    };
    /**
    * @typedef {Object} editorCopyImagesParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_copy_images. Evid: 140.
     * Event description: editor_copy_images.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * set_id - Type: string. Desc: -
     * @param {editorCopyImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorCopyImages = function (params) {
        return this.bi.log(__assign({ evid: 140 }, params));
    };
    /**
    * @typedef {Object} popupLockListProofingClickParams
    * @property {string} albumID - album_id
    * @property {string} buttonName - cancel/lock list
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Popup Lock List Proofing Click. Evid: 267.
     * Event description: when user click in the  pop up of lock a list in the proofing.
    
     * albumID - Type: string. Desc: album_id
     *
     * buttonName - Type: string. Desc: cancel/lock list
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {popupLockListProofingClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popupLockListProofingClick = function (params) {
        return this.bi.log(__assign({ evid: 267 }, params));
    };
    /**
    * @typedef {Object} startUploadToMediaSingleItemParams
    * @property {string} albumID - .
    * @property {string} batchId - .
    * @property {string} contentType - The type of the file
    * @property {string} correlationID - Instead of the lacking file_id
    * @property {number} fileSize - File Size in bits
    * @property {GUID} instance_id - null
    * @property {boolean} isSecure - Upload to Secured Media or not
    * @property {string} mediaType - Photo/Video
    * @property {string} mediaURL - .
    * @property {GUID} biToken - null
    * @property {string} origin - .
    * @property {string} setID - .
    **/
    /**
     * Name: Start Upload To Media - Single Item. Evid: 190.
     * Event description: Indicates the beginning of a single-file upload.
    
     * albumID - Type: string. Desc: .
     *
     * batchId - Type: string. Desc: .
     *
     * contentType - Type: string. Desc: The type of the file
     *
     * correlationID - Type: string. Desc: Instead of the lacking file_id
     *
     * fileSize - Type: numeric. Desc: File Size in bits
     *
     * instance_id - Type: guid.
     *
     * isSecure - Type: bool. Desc: Upload to Secured Media or not
     *
     * mediaType - Type: string. Desc: Photo/Video
     *
     * mediaURL - Type: string. Desc: .
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: .
     *
     * setID - Type: string. Desc: .
     * @param {startUploadToMediaSingleItemParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.startUploadToMediaSingleItem = function (params) {
        return this.bi.log(__assign({ evid: 190 }, params));
    };
    /**
    * @typedef {Object} popupLockListProofingOpenParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Popup Lock List Proofing open. Evid: 266.
     * Event description: when the pop up of lock a list in the proofing.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {popupLockListProofingOpenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popupLockListProofingOpen = function (params) {
        return this.bi.log(__assign({ evid: 266 }, params));
    };
    /**
    * @typedef {Object} photoAlbumsSearchInAlbumListParams
    * @property {GUID} instance_id - .
    * @property {GUID} biToken - .
    * @property {string} origin - Editor, BM, custom origin
    * @property {string} searchTerm - the term of the search
    **/
    /**
     * Name: PhotoAlbums - Search In Album List. Evid: 243.
     * Event description: arrive when the user search in the albums list.
    
     * instance_id - Type: guid. Desc: .
     *
     * biToken - Type: guid. Desc: .
     *
     * origin - Type: string. Desc: Editor, BM, custom origin
     *
     * searchTerm - Type: string. Desc: the term of the search
     * @param {photoAlbumsSearchInAlbumListParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumsSearchInAlbumList = function (params) {
        return this.bi.log(__assign({ evid: 243 }, params));
    };
    /**
    * @typedef {Object} editorUploadImagesParams
    * @property {string} albumID - []
    * @property {string} albumVersion - photo album 2.0 or old
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_images - []
    * @property {string} origin - Editor, BM
    * @property {string} photo_site_id - -
    * @property {number} precentage - -
    **/
    /**
     * Name: editor_upload_images. Evid: 117.
     * Event description: sent when images are actually loaded on the album.
    
     * albumID - Type: string. Desc: []
     *
     * albumVersion - Type: string. Desc: photo album 2.0 or old
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_images - Type: numeric. Desc: []
     *
     * origin - Type: string. Desc: Editor, BM
     *
     * photo_site_id - Type: string. Desc: -
     *
     * precentage - Type: numeric. Desc: -
     * @param {editorUploadImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorUploadImages = function (params) {
        return this.bi.log(__assign({ evid: 117 }, params));
    };
    /**
    * @typedef {Object} oaClickOnGalleryParams
    * @property {GUID} gallery_id - []
    * @property {number} gallery_index - gallery placement in the list
    * @property {GUID} instance_id - null
    * @property {GUID} biToken -
    * @property {string} origin - [member_view or manage_view]
    **/
    /**
     * Name: OA click on gallery. Evid: 513.
     * Event description: user click on a gallery from the gallery list (both in member view and in manage).
    
     * gallery_id - Type: guid. Desc: []
     *
     * gallery_index - Type: numeric. Desc: gallery placement in the list
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: [member_view or manage_view]
     * @param {oaClickOnGalleryParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaClickOnGallery = function (params) {
        return this.bi.log(__assign({ evid: 513 }, params));
    };
    /**
    * @typedef {Object} photoAlbumDashboardNavigation178Params
    * @property {GUID} app_site_id - -
    * @property {string} category - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} sub_category - []
    **/
    /**
     * Name: photo album-->dashboard-->navigation. Evid: 178.
     * Event description: albums_list_view- page appear.
    
     * app_site_id - Type: guid. Desc: -
     *
     * category - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * sub_category - Type: string. Desc: []
     * @param {photoAlbumDashboardNavigation178Params} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumDashboardNavigation178 = function (params) {
        return this.bi.log(__assign({ evid: 178 }, params));
    };
    /**
    * @typedef {Object} addCommentOnAnItemCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {string} itemId - id of the chosen item
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} source - preview/selected_media/discussions
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Add Comment On An Item Collection. Evid: 229.
     * Event description: Arrived when collection member add comment on an item.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * itemId - Type: string. Desc: id of the chosen item
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * source - Type: string. Desc: preview/selected_media/discussions
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {addCommentOnAnItemCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.addCommentOnAnItemCollection = function (params) {
        return this.bi.log(__assign({ evid: 229 }, params));
    };
    /**
    * @typedef {Object} oaReorderGalleryInGalleriesSettingsParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA reorder gallery in galleries settings. Evid: 527.
     * Event description: user reorders galleries in the settings of the manage gallery in OA.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {oaReorderGalleryInGalleriesSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaReorderGalleryInGalleriesSettings = function (params) {
        return this.bi.log(__assign({ evid: 527 }, params));
    };
    /**
    * @typedef {Object} licenseLicenseDeleteParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: license-->license delete. Evid: 716.
     * Event description: delete license.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {licenseLicenseDeleteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseLicenseDelete = function (params) {
        return this.bi.log(__assign({ evid: 716 }, params));
    };
    /**
    * @typedef {Object} popupBannerHideMemberLoginOpenParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Popup Banner Hide Member Login Open. Evid: 260.
     * Event description: when the banner of hide login member id open.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {popupBannerHideMemberLoginOpenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popupBannerHideMemberLoginOpen = function (params) {
        return this.bi.log(__assign({ evid: 260 }, params));
    };
    /**
    * @typedef {Object} chooseSortingOptionParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    * @property {string} value - newest first/oldest first/manually
    **/
    /**
     * Name: Choose sorting option. Evid: 249.
     * Event description: choose how albums will be sorted in ADI settings.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * value - Type: string. Desc: newest first/oldest first/manually
     * @param {chooseSortingOptionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.chooseSortingOption = function (params) {
        return this.bi.log(__assign({ evid: 249 }, params));
    };
    /**
    * @typedef {Object} clickOnUpgradeParams
    * @property {string} album_id - album id
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - from which button the user clicked (publish pop up, etc..)
    **/
    /**
     * Name: Click on Upgrade. Evid: 171.
     * Event description: user clicked on upgrade button.
    
     * album_id - Type: string. Desc: album id
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: from which button the user clicked (publish pop up, etc..)
     * @param {clickOnUpgradeParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnUpgrade = function (params) {
        return this.bi.log(__assign({ evid: 171 }, params));
    };
    /**
    * @typedef {Object} settingsClickDownloadLrPluginParams
    * @property {GUID} instance_id - instance ID
    * @property {string} lightroomVersion - version
    * @property {GUID} biToken - msid
    * @property {string} origin - Main
    **/
    /**
     * Name: Click Download LR Plugin. Evid: 240.
     * Event description: click on the download Lightroom plugin link from photo album settings or pro gallery.
    
     * instance_id - Type: guid. Desc: instance ID
     *
     * lightroomVersion - Type: string. Desc: version
     *
     * biToken - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Main
     * @param {settingsClickDownloadLrPluginParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsClickDownloadLrPlugin = function (params) {
        return this.bi.log(__assign({ evid: 240 }, params));
    };
    /**
    * @typedef {Object} filterListsInTheBoParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} value - ll list / created by me / created by others
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Filter Lists In The Bo. Evid: 269.
    
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * value - Type: string. Desc: ll list / created by me / created by others
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {filterListsInTheBoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.filterListsInTheBo = function (params) {
        return this.bi.log(__assign({ evid: 269 }, params));
    };
    /**
    * @typedef {Object} removeMediaParams
    * @property {number} count - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} source - .
    * @property {string} type - null
    **/
    /**
     * Name: remove_media. Evid: 408.
     * Event description: Remove_media.
    
     * count - Type: numeric.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: .
     *
     * type - Type: string.
     * @param {removeMediaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.removeMedia = function (params) {
        return this.bi.log(__assign({ evid: 408 }, params));
    };
    /**
    * @typedef {Object} openAlbumsAppearanceOptionsParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    **/
    /**
     * Name: Open albums appearance options. Evid: 246.
     * Event description: Open how album appears options in ADI settings.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     * @param {openAlbumsAppearanceOptionsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openAlbumsAppearanceOptions = function (params) {
        return this.bi.log(__assign({ evid: 246 }, params));
    };
    /**
    * @typedef {Object} editorDialogHelpParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selection - {photos, design, details, settings, publish}
    **/
    /**
     * Name: editor_dialog_help. Evid: 133.
     * Event description: editor_dialog_help.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {photos, design, details, settings, publish}
     * @param {editorDialogHelpParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorDialogHelp = function (params) {
        return this.bi.log(__assign({ evid: 133 }, params));
    };
    /**
    * @typedef {Object} settingsMyAlbumsTabClickParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} tab_name - {all, visible}
    **/
    /**
     * Name: settings_my_albums_tab_click. Evid: 155.
     * Event description: settings_my_albums_tab_click - inside my albums (all albums and visible albums).
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * tab_name - Type: string. Desc: {all, visible}
     * @param {settingsMyAlbumsTabClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsMyAlbumsTabClick = function (params) {
        return this.bi.log(__assign({ evid: 155 }, params));
    };
    /**
    * @typedef {Object} clickDoneProofingSettingsParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} params - save parmas json type
    **/
    /**
     * Name: Click Done Proofing Settings. Evid: 259.
     * Event description: when user click done in the proofing settings.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * params - Type: string. Desc: save parmas json type
     * @param {clickDoneProofingSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickDoneProofingSettings = function (params) {
        return this.bi.log(__assign({ evid: 259 }, params));
    };
    /**
    * @typedef {Object} licenseToggleParams
    * @property {string} app_id - null
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - license name
    * @property {GUID} storeId - gallery_id
    * @property {string} value - on/off
    **/
    /**
     * Name: license-->toggle. Evid: 719.
     * Event description: toggle license on/off.
    
     * app_id - Type: string.
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: license name
     *
     * storeId - Type: guid. Desc: gallery_id
     *
     * value - Type: string. Desc: on/off
     * @param {licenseToggleParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseToggle = function (params) {
        return this.bi.log(__assign({ evid: 719 }, params));
    };
    /**
    * @typedef {Object} changeSettingsParams
    * @property {string} category - null
    * @property {string} controll_name - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - null
    * @property {boolean} isMobile - 1 for mobile editor - 0 for regular editor
    * @property {boolean} is_store - null
    * @property {GUID} biToken - null
    * @property {string} origin - null
    * @property {string} sub_category - null
    * @property {string} value - null
    **/
    /**
     * Name: change_settings. Evid: 401.
     * Event description: pro gallery settings change.
    
     * category - Type: string.
     *
     * controll_name - Type: string.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid.
     *
     * isMobile - Type: bool. Desc: 1 for mobile editor - 0 for regular editor
     *
     * is_store - Type: bool.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string.
     *
     * sub_category - Type: string.
     *
     * value - Type: string.
     * @param {changeSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.changeSettings = function (params) {
        return this.bi.log(__assign({ evid: 401 }, params));
    };
    /**
    * @typedef {Object} openCollectionActionMenuParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Open Collection Action Menu. Evid: 209.
     * Event description: open collection action menu.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {openCollectionActionMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openCollectionActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 209 }, params));
    };
    /**
    * @typedef {Object} shareAlbumCancelParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    **/
    /**
     * Name: share_album_cancel. Evid: 107.
     * Event description: share_album_cancel.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     * @param {shareAlbumCancelParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.shareAlbumCancel = function (params) {
        return this.bi.log(__assign({ evid: 107 }, params));
    };
    /**
    * @typedef {Object} oaChangeGalleryOrderParams
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: OA Change gallery order. Evid: 546.
    
    
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {oaChangeGalleryOrderParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaChangeGalleryOrder = function (params) {
        return this.bi.log(__assign({ evid: 546 }, params));
    };
    /**
    * @typedef {Object} organizeMediaRearrangeGalleryParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} type - []
    **/
    /**
     * Name: Organize Media - Rearrange Gallery. Evid: 277.
    
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * type - Type: string. Desc: []
     * @param {organizeMediaRearrangeGalleryParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.organizeMediaRearrangeGallery = function (params) {
        return this.bi.log(__assign({ evid: 277 }, params));
    };
    /**
    * @typedef {Object} userClickOnStartProofingWizardParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: User Click On Start Proofing Wizard. Evid: 196.
     * Event description: this events fired when the user click for the first time start wizard.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {userClickOnStartProofingWizardParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.userClickOnStartProofingWizard = function (params) {
        return this.bi.log(__assign({ evid: 196 }, params));
    };
    /**
    * @typedef {Object} wizardLayoutClickParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selection - {party,newborn,weddings1,weddings2,modeling,engagement}
    **/
    /**
     * Name: wizard_layout_click. Evid: 112.
     * Event description: wizard_layout_click.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {party,newborn,weddings1,weddings2,modeling,engagement}
     * @param {wizardLayoutClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardLayoutClick = function (params) {
        return this.bi.log(__assign({ evid: 112 }, params));
    };
    /**
    * @typedef {Object} artStoreCompletedBusinessInfoParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} providerId - []
    **/
    /**
     * Name: art store --> completed business info. Evid: 184.
     * Event description: users completed putting in business info.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * providerId - Type: string. Desc: []
     * @param {artStoreCompletedBusinessInfoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStoreCompletedBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 184 }, params));
    };
    /**
    * @typedef {Object} oaGalleriesFilterParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - [open filter menu when null]
    **/
    /**
     * Name: OA galleries filter. Evid: 522.
     * Event description: Filter galleries in Manage pro gallery screen.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: [open filter menu when null]
     * @param {oaGalleriesFilterParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleriesFilter = function (params) {
        return this.bi.log(__assign({ evid: 522 }, params));
    };
    /**
    * @typedef {Object} nativePhotoAlbumActionParams
    * @property {string} action - action name - create/open
    * @property {string} install_id - installation_id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Native Photo album --> Action. Evid: 183.
     * Event description: click on create/open from native Apple app.
    
     * action - Type: string. Desc: action name - create/open
     *
     * install_id - Type: string. Desc: installation_id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {nativePhotoAlbumActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.nativePhotoAlbumAction = function (params) {
        return this.bi.log(__assign({ evid: 183 }, params));
    };
    /**
    * @typedef {Object} click3DotsParams
    * @property {GUID} gallery_id - .
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - .
    * @property {GUID} biToken - []
    * @property {string} source - .
    * @property {string} type - .
    **/
    /**
     * Name: Click on 3 dots. Evid: 284.
     * Event description: click on 3 dots.
    
     * gallery_id - Type: guid. Desc: .
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid. Desc: .
     *
     * biToken - Type: guid. Desc: []
     *
     * source - Type: string. Desc: .
     *
     * type - Type: string. Desc: .
     * @param {click3DotsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.click3Dots = function (params) {
        return this.bi.log(__assign({ evid: 284 }, params));
    };
    /**
    * @typedef {Object} collectionCreatedParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} origin - collection settings/ new collection / LiveSite
    * @property {string} params - collection params
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Collection Created. Evid: 199.
     * Event description: arrived when the collection created.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: collection settings/ new collection / LiveSite
     *
     * params - Type: string. Desc: collection params
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {collectionCreatedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.collectionCreated = function (params) {
        return this.bi.log(__assign({ evid: 199 }, params));
    };
    /**
    * @typedef {Object} clickOnActionFromCollectionActionMenuParams
    * @property {string} albumID - album_id
    * @property {string} button_name - action name
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click on Action from Collection Action Menu. Evid: 215.
     * Event description: when user click on an action from the menu.
    
     * albumID - Type: string. Desc: album_id
     *
     * button_name - Type: string. Desc: action name
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnActionFromCollectionActionMenuParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnActionFromCollectionActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 215 }, params));
    };
    /**
    * @typedef {Object} wizardBackParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} screen_clicked - {types,details,layouts,done}
    **/
    /**
     * Name: wizard_back. Evid: 131.
     * Event description: wizard_back.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * screen_clicked - Type: string. Desc: {types,details,layouts,done}
     * @param {wizardBackParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardBack = function (params) {
        return this.bi.log(__assign({ evid: 131 }, params));
    };
    /**
    * @typedef {Object} albumActionsParams
    * @property {string} action - -
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: album_actions. Evid: 300.
     * Event description: album_actions.
    
     * action - Type: string. Desc: -
     *
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {albumActionsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.albumActions = function (params) {
        return this.bi.log(__assign({ evid: 300 }, params));
    };
    /**
    * @typedef {Object} generateDownloadLinkForSetEndedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_photos - -
    * @property {string} set_id - -
    **/
    /**
     * Name: generate_download_link_for_set_ended. Evid: 170.
     * Event description: generate_download_link_for_set_ended.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_photos - Type: numeric. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {generateDownloadLinkForSetEndedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.generateDownloadLinkForSetEnded = function (params) {
        return this.bi.log(__assign({ evid: 170 }, params));
    };
    /**
    * @typedef {Object} saveProofingSettingParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} params - Proofing settings params
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Save Proofing Setting. Evid: 227.
     * Event description: arrived when the user edit proofing settings.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * params - Type: string. Desc: Proofing settings params
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {saveProofingSettingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.saveProofingSetting = function (params) {
        return this.bi.log(__assign({ evid: 227 }, params));
    };
    /**
    * @typedef {Object} editorClickOnSetParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_click_on_set. Evid: 118.
     * Event description: editor_click_on_set.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {editorClickOnSetParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorClickOnSet = function (params) {
        return this.bi.log(__assign({ evid: 118 }, params));
    };
    /**
    * @typedef {Object} editProofingSettingParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Edit Proofing Setting. Evid: 226.
     * Event description: arrived when the user edit proofing settings.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {editProofingSettingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editProofingSetting = function (params) {
        return this.bi.log(__assign({ evid: 226 }, params));
    };
    /**
    * @typedef {Object} settingsLayoutSelectedParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} skin_name - -
    **/
    /**
     * Name: settings_layout_selected. Evid: 151.
     * Event description: settings_layout_selected.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * skin_name - Type: string. Desc: -
     * @param {settingsLayoutSelectedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsLayoutSelected = function (params) {
        return this.bi.log(__assign({ evid: 151 }, params));
    };
    /**
    * @typedef {Object} licenseClickChangeCurrencyParams
    * @property {string} app_id - []
    * @property {string} currency - currency
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - []
    * @property {GUID} storeId - store_id
    **/
    /**
     * Name: license-->click change currency. Evid: 717.
     * Event description: click on change currency.
    
     * app_id - Type: string. Desc: []
     *
     * currency - Type: string. Desc: currency
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: []
     *
     * storeId - Type: guid. Desc: store_id
     * @param {licenseClickChangeCurrencyParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseClickChangeCurrency = function (params) {
        return this.bi.log(__assign({ evid: 717 }, params));
    };
    /**
    * @typedef {Object} watermarkEnableParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    * @property {string} value - null
    **/
    /**
     * Name: watermark-->enable. Evid: 706.
     * Event description: enable watermark.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     *
     * value - Type: string.
     * @param {watermarkEnableParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.watermarkEnable = function (params) {
        return this.bi.log(__assign({ evid: 706 }, params));
    };
    /**
    * @typedef {Object} photoAlbumAppOnSaveParams
    * @property {string} albumID - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Editor, BM
    * @property {string} params - json with params
    * @property {string} screenName - []
    **/
    /**
     * Name: PhotoAlbum.App.onSave. Evid: 212.
     * Event description: A save event in Photo album 2.0.
    
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Editor, BM
     *
     * params - Type: string. Desc: json with params
     *
     * screenName - Type: string. Desc: []
     * @param {photoAlbumAppOnSaveParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumAppOnSave = function (params) {
        return this.bi.log(__assign({ evid: 212 }, params));
    };
    /**
    * @typedef {Object} manageStoreLoadNewParams
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} origin - []
    * @property {GUID} providerId - []
    **/
    /**
     * Name: manage store-->load new. Evid: 733.
     * Event description: the store manager loaded - Wix and Providers.
    
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * origin - Type: string. Desc: []
     *
     * providerId - Type: guid. Desc: []
     * @param {manageStoreLoadNewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageStoreLoadNew = function (params) {
        return this.bi.log(__assign({ evid: 733 }, params));
    };
    /**
    * @typedef {Object} editorUploadTriggerParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selection - {button, drag}
    **/
    /**
     * Name: editor_upload_trigger. Evid: 134.
     * Event description: editor_upload_trigger.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {button, drag}
     * @param {editorUploadTriggerParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorUploadTrigger = function (params) {
        return this.bi.log(__assign({ evid: 134 }, params));
    };
    /**
    * @typedef {Object} backofficeLoadedParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - {editor, my account}
    **/
    /**
     * Name: backoffice_loaded. Evid: 157.
     * Event description: backoffice_loaded.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: {editor, my account}
     * @param {backofficeLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.backofficeLoaded = function (params) {
        return this.bi.log(__assign({ evid: 157 }, params));
    };
    /**
    * @typedef {Object} navigateInTheCollectionBzmAreaParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} screenName - selected media/ collection members/ collection info
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Navigate In The Collection - Bzm Area. Evid: 222.
     * Event description: each time the user navigate between the screen in the BZM.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * screenName - Type: string. Desc: selected media/ collection members/ collection info
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {navigateInTheCollectionBzmAreaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.navigateInTheCollectionBzmArea = function (params) {
        return this.bi.log(__assign({ evid: 222 }, params));
    };
    /**
    * @typedef {Object} adiSettingsClickManageAlbumsParams
    * @property {GUID} instance_id - -
    * @property {GUID} biToken - -
    * @property {string} origin - screen name in settings
    **/
    /**
     * Name: ADI settings click manage albums. Evid: 255.
    
    
     * instance_id - Type: guid. Desc: -
     *
     * biToken - Type: guid. Desc: -
     *
     * origin - Type: string. Desc: screen name in settings
     * @param {adiSettingsClickManageAlbumsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.adiSettingsClickManageAlbums = function (params) {
        return this.bi.log(__assign({ evid: 255 }, params));
    };
    /**
    * @typedef {Object} wizardStartedParams
    * @property {string} albumVersion - photo album 2.0 or old
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Editor, BM
    * @property {string} wizard_type - -
    **/
    /**
     * Name: wizard_started. Evid: 109.
     * Event description: wizard_started.
    
     * albumVersion - Type: string. Desc: photo album 2.0 or old
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Editor, BM
     *
     * wizard_type - Type: string. Desc: -
     * @param {wizardStartedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardStarted = function (params) {
        return this.bi.log(__assign({ evid: 109 }, params));
    };
    /**
    * @typedef {Object} userLoggedInToProofingParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} source - whatsapp/link/etc..
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: User Logged In To Proofing. Evid: 235.
     * Event description: when a visitor click on log in to the proofing.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * source - Type: string. Desc: whatsapp/link/etc..
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {userLoggedInToProofingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.userLoggedInToProofing = function (params) {
        return this.bi.log(__assign({ evid: 235 }, params));
    };
    /**
    * @typedef {Object} openProofingBoParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Open Proofing BO. Evid: 207.
    
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {openProofingBoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openProofingBo = function (params) {
        return this.bi.log(__assign({ evid: 207 }, params));
    };
    /**
    * @typedef {Object} oaClickOnMediaInExpandParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} media_type - This event is currently generating for media_type:"Photo" only
    * @property {GUID} biToken -
    **/
    /**
     * Name: OA click on media in expand. Evid: 519.
     * Event description: user clicks on a media in a gallery in expand mode.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * media_type - Type: string. Desc: This event is currently generating for media_type:"Photo" only
     *
     * biToken - Type: guid.
     * @param {oaClickOnMediaInExpandParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaClickOnMediaInExpand = function (params) {
        return this.bi.log(__assign({ evid: 519 }, params));
    };
    /**
    * @typedef {Object} settingsManageAlbumsClickParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {boolean} is_first_time - -
    * @property {GUID} biToken - null
    **/
    /**
     * Name: settings_manage_albums_click. Evid: 150.
     * Event description: settings_manage_albums_click.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * is_first_time - Type: bool. Desc: -
     *
     * biToken - Type: guid.
     * @param {settingsManageAlbumsClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsManageAlbumsClick = function (params) {
        return this.bi.log(__assign({ evid: 150 }, params));
    };
    /**
    * @typedef {Object} shareAlbumParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - {share, publish}
    * @property {string} photo_site_id - -
    * @property {string} type - (mail, facebook, twitter)
    **/
    /**
     * Name: share_album. Evid: 106.
     * Event description: share_album.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: {share, publish}
     *
     * photo_site_id - Type: string. Desc: -
     *
     * type - Type: string. Desc: (mail, facebook, twitter)
     * @param {shareAlbumParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.shareAlbum = function (params) {
        return this.bi.log(__assign({ evid: 106 }, params));
    };
    /**
    * @typedef {Object} photoAlbumButtonOnClickParams
    * @property {string} albumID - []
    * @property {string} buttonName - []
    * @property {string} buttonOrigin - []
    * @property {GUID} instance_id - null
    * @property {string} lightroomVersion - version
    * @property {GUID} biToken - null
    * @property {string} origin - Editor, BM, custom origin
    * @property {string} screenName - []
    **/
    /**
     * Name: PhotoAlbum.Button.onClick. Evid: 211.
     * Event description: A click event in Photo album 2.0.
    
     * albumID - Type: string. Desc: []
     *
     * buttonName - Type: string. Desc: []
     *
     * buttonOrigin - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * lightroomVersion - Type: string. Desc: version
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Editor, BM, custom origin
     *
     * screenName - Type: string. Desc: []
     * @param {photoAlbumButtonOnClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumButtonOnClick = function (params) {
        return this.bi.log(__assign({ evid: 211 }, params));
    };
    /**
    * @typedef {Object} publishInAlbumsEndedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} template_name - layout name
    **/
    /**
     * Name: publish_in_albums_ended. Evid: 165.
     * Event description: publish_in_albums_ended.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * template_name - Type: string. Desc: layout name
     * @param {publishInAlbumsEndedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.publishInAlbumsEnded = function (params) {
        return this.bi.log(__assign({ evid: 165 }, params));
    };
    /**
    * @typedef {Object} artStoreNavigationParams
    * @property {string} app_id - []
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - page_name
    **/
    /**
     * Name: art store --> navigation. Evid: 732.
     * Event description: navigation in the dashboard.
    
     * app_id - Type: string. Desc: []
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: page_name
     * @param {artStoreNavigationParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStoreNavigation = function (params) {
        return this.bi.log(__assign({ evid: 732 }, params));
    };
    /**
    * @typedef {Object} oaGalleryLayoutChangeParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} layout_type - type of layout
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA gallery Layout change. Evid: 514.
     * Event description: user click on a different gallery layout.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * layout_type - Type: string. Desc: type of layout
     *
     * biToken - Type: guid.
     * @param {oaGalleryLayoutChangeParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleryLayoutChange = function (params) {
        return this.bi.log(__assign({ evid: 514 }, params));
    };
    /**
    * @typedef {Object} editorUploadPhotosParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_images - -
    **/
    /**
     * Name: editor_upload_photos. Evid: 135.
     * Event description: editor_upload_photos - in photos dialog - Deprecated.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_images - Type: numeric. Desc: -
     * @param {editorUploadPhotosParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorUploadPhotos = function (params) {
        return this.bi.log(__assign({ evid: 135 }, params));
    };
    /**
    * @typedef {Object} oaPhotoAlbumNavigationParams
    * @property {string} category - which tab was clicked
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA Photo Album - Navigation. Evid: 540.
     * Event description: user clicks on a navigation tab in photo album.
    
     * category - Type: string. Desc: which tab was clicked
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid.
     * @param {oaPhotoAlbumNavigationParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaPhotoAlbumNavigation = function (params) {
        return this.bi.log(__assign({ evid: 540 }, params));
    };
    /**
    * @typedef {Object} photoAlbumAppleCreateParams
    * @property {string} install_id - installation id
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: Photo album --> Apple --> Create. Evid: 181.
     * Event description: creating an album from Apple flow.
    
     * install_id - Type: string. Desc: installation id
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {photoAlbumAppleCreateParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumAppleCreate = function (params) {
        return this.bi.log(__assign({ evid: 181 }, params));
    };
    /**
    * @typedef {Object} wizardTypeClickParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selection - {wedding,family,party,baby,models,other}
    **/
    /**
     * Name: wizard_type_click. Evid: 111.
     * Event description: wizard_type_click.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {wedding,family,party,baby,models,other}
     * @param {wizardTypeClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardTypeClick = function (params) {
        return this.bi.log(__assign({ evid: 111 }, params));
    };
    /**
    * @typedef {Object} layoutsSelectParams
    * @property {string} controll_name - {}
    * @property {GUID} gallery_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} value - {}
    **/
    /**
     * Name: layouts_select. Evid: 409.
     * Event description: Layouts_select.
    
     * controll_name - Type: string. Desc: {}
     *
     * gallery_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * value - Type: string. Desc: {}
     * @param {layoutsSelectParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.layoutsSelect = function (params) {
        return this.bi.log(__assign({ evid: 409 }, params));
    };
    /**
    * @typedef {Object} manageStoreEmailSettingsParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - gallery_id
    * @property {string} value - on/off
    **/
    /**
     * Name: manage store-->email settings. Evid: 723.
     * Event description: toggle email settings.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid. Desc: gallery_id
     *
     * value - Type: string. Desc: on/off
     * @param {manageStoreEmailSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageStoreEmailSettings = function (params) {
        return this.bi.log(__assign({ evid: 723 }, params));
    };
    /**
    * @typedef {Object} endUploadToMediaBatchParams
    * @property {string} albumID - .
    * @property {number} batchCount - How many files in the batch
    * @property {string} batchId - .
    * @property {number} batchSize - Size in bits
    * @property {number} duration - In milliseconds
    * @property {GUID} instance_id - null
    * @property {boolean} isAllSuccessed - .
    * @property {GUID} biToken - null
    * @property {number} num_failed - How many of the files failed to load
    * @property {number} num_succeed - How many of the files were uploaded successfully
    * @property {string} origin - .
    * @property {string} setID - .
    * @property {string} type - image\folder
    **/
    /**
     * Name: End Upload To Media - Batch. Evid: 193.
     * Event description: Indicates the end of a batch upload.
    
     * albumID - Type: string. Desc: .
     *
     * batchCount - Type: numeric. Desc: How many files in the batch
     *
     * batchId - Type: string. Desc: .
     *
     * batchSize - Type: numeric. Desc: Size in bits
     *
     * duration - Type: numeric. Desc: In milliseconds
     *
     * instance_id - Type: guid.
     *
     * isAllSuccessed - Type: bool. Desc: .
     *
     * biToken - Type: guid.
     *
     * num_failed - Type: numeric. Desc: How many of the files failed to load
     *
     * num_succeed - Type: numeric. Desc: How many of the files were uploaded successfully
     *
     * origin - Type: string. Desc: .
     *
     * setID - Type: string. Desc: .
     *
     * type - Type: string. Desc: image\folder
     * @param {endUploadToMediaBatchParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.endUploadToMediaBatch = function (params) {
        return this.bi.log(__assign({ evid: 193 }, params));
    };
    /**
    * @typedef {Object} inviteMembersToCollectionParams
    * @property {string} albumID - album_id
    * @property {string} buttonName - (copy link\email\whatsapp \etc..)
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} origin - collection creation/BO
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Invite Members To Collection. Evid: 206.
     * Event description: arrived when user invite new members to the collection.
    
     * albumID - Type: string. Desc: album_id
     *
     * buttonName - Type: string. Desc: (copy link\email\whatsapp \etc..)
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: collection creation/BO
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {inviteMembersToCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.inviteMembersToCollection = function (params) {
        return this.bi.log(__assign({ evid: 206 }, params));
    };
    /**
    * @typedef {Object} manageMediaTextEditorCustomizeParams
    * @property {string} controll_name - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} value - null
    **/
    /**
     * Name: manage_media_text_editor_customize. Evid: 405.
     * Event description: text editor changes.
    
     * controll_name - Type: string.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * value - Type: string.
     * @param {manageMediaTextEditorCustomizeParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageMediaTextEditorCustomize = function (params) {
        return this.bi.log(__assign({ evid: 405 }, params));
    };
    /**
    * @typedef {Object} uploadMediaErrorParams
    * @property {number} count - {}
    * @property {GUID} gallery_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} type - {Photo, Video}
    **/
    /**
     * Name: upload_media_error. Evid: 407.
     * Event description: Upload_media_error.
    
     * count - Type: numeric. Desc: {}
     *
     * gallery_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * type - Type: string. Desc: {Photo, Video}
     * @param {uploadMediaErrorParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.uploadMediaError = function (params) {
        return this.bi.log(__assign({ evid: 407 }, params));
    };
    /**
    * @typedef {Object} licenseCreateLicenseClickParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: license-->create license click. Evid: 712.
     * Event description: click on create license.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {licenseCreateLicenseClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseCreateLicenseClick = function (params) {
        return this.bi.log(__assign({ evid: 712 }, params));
    };
    /**
    * @typedef {Object} loadingScreenParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} stage - -
    **/
    /**
     * Name: loading_screen. Evid: 132.
     * Event description: loading_screen.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * stage - Type: string. Desc: -
     * @param {loadingScreenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.loadingScreen = function (params) {
        return this.bi.log(__assign({ evid: 132 }, params));
    };
    /**
    * @typedef {Object} oaPhotoAlbumReplaceCoverParams
    * @property {GUID} album_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} source - []
    * @property {string} stage - click (on replace icon), source, choose (item), upload (successful)
    **/
    /**
     * Name: OA Photo Album - Replace cover. Evid: 538.
     * Event description: user click to replace cover of the Photo album in OA.
    
     * album_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * source - Type: string. Desc: []
     *
     * stage - Type: string. Desc: click (on replace icon), source, choose (item), upload (successful)
     * @param {oaPhotoAlbumReplaceCoverParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaPhotoAlbumReplaceCover = function (params) {
        return this.bi.log(__assign({ evid: 538 }, params));
    };
    /**
    * @typedef {Object} artStoreConnectProviderParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} providerId - null
    **/
    /**
     * Name: art store --> connect provider. Evid: 734.
     * Event description: user connects to a provider in art store.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * providerId - Type: string.
     * @param {artStoreConnectProviderParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStoreConnectProvider = function (params) {
        return this.bi.log(__assign({ evid: 734 }, params));
    };
    /**
    * @typedef {Object} oaCloseEditGalleriesParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - []
    **/
    /**
     * Name: OA Close edit galleries. Evid: 547.
     * Event description: user clicks on save or 'x' in the settings of the manage gallery in OA (photo store).
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid. Desc: []
     * @param {oaCloseEditGalleriesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaCloseEditGalleries = function (params) {
        return this.bi.log(__assign({ evid: 547 }, params));
    };
    /**
    * @typedef {Object} popupOpenedParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - []
    * @property {string} origin - origin that opened popup
    * @property {string} popupName - popup title/description
    * @property {string} role - member/owner
    **/
    /**
     * Name: Popup Opened. Evid: 279.
     * Event description: when a popup is presented to a user.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: []
     *
     * origin - Type: string. Desc: origin that opened popup
     *
     * popupName - Type: string. Desc: popup title/description
     *
     * role - Type: string. Desc: member/owner
     * @param {popupOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popupOpened = function (params) {
        return this.bi.log(__assign({ evid: 279 }, params));
    };
    /**
    * @typedef {Object} wizardCloseParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} screen_clicked - {types,details,layouts,done}
    **/
    /**
     * Name: wizard_close. Evid: 130.
     * Event description: wizard_close.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * screen_clicked - Type: string. Desc: {types,details,layouts,done}
     * @param {wizardCloseParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wizardClose = function (params) {
        return this.bi.log(__assign({ evid: 130 }, params));
    };
    /**
    * @typedef {Object} cartDesignTabParams
    * @property {string} control_name - null
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - null
    * @property {string} value - null
    **/
    /**
     * Name: cart-->design tab. Evid: 709.
     * Event description: click on customize icon.
    
     * control_name - Type: string.
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid.
     *
     * value - Type: string.
     * @param {cartDesignTabParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.cartDesignTab = function (params) {
        return this.bi.log(__assign({ evid: 709 }, params));
    };
    /**
    * @typedef {Object} photoAlbumStoreSetPricingParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - orders/licenses/payment/bus info
    * @property {string} products_results - map with all products: {Digital Images:true, Phone cases:false...}
    * @property {GUID} providerId - provider id
    **/
    /**
     * Name: Photo Album store --> set Pricing. Evid: 187.
     * Event description: this is for step 2, set pricing in the store.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: orders/licenses/payment/bus info
     *
     * products_results - Type: string. Desc: map with all products: {Digital Images:true, Phone cases:false...}
     *
     * providerId - Type: guid. Desc: provider id
     * @param {photoAlbumStoreSetPricingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumStoreSetPricing = function (params) {
        return this.bi.log(__assign({ evid: 187 }, params));
    };
    /**
    * @typedef {Object} editorDeleteSetParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_delete_set. Evid: 145.
     * Event description: editor_delete_set.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * set_id - Type: string. Desc: -
     * @param {editorDeleteSetParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorDeleteSet = function (params) {
        return this.bi.log(__assign({ evid: 145 }, params));
    };
    /**
    * @typedef {Object} clickOnDownloadFilesFromCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} source - bzm/member area
    * @property {string} type - csv/zip
    * @property {string} value - single image/collection
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click on Download Files From Collection. Evid: 216.
     * Event description: when user click on download files.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: bzm/member area
     *
     * type - Type: string. Desc: csv/zip
     *
     * value - Type: string. Desc: single image/collection
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnDownloadFilesFromCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnDownloadFilesFromCollection = function (params) {
        return this.bi.log(__assign({ evid: 216 }, params));
    };
    /**
    * @typedef {Object} firstOpenProofingWizardParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} origin - where the proofing wizard was opened from
    **/
    /**
     * Name: First Open Proofing Wizard. Evid: 195.
     * Event description: this events fired when the user click for the first time open wizard.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: where the proofing wizard was opened from
     * @param {firstOpenProofingWizardParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.firstOpenProofingWizard = function (params) {
        return this.bi.log(__assign({ evid: 195 }, params));
    };
    /**
    * @typedef {Object} editorReorderPhotosParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_reorder_photos. Evid: 123.
     * Event description: editor_reorder_photos.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {editorReorderPhotosParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorReorderPhotos = function (params) {
        return this.bi.log(__assign({ evid: 123 }, params));
    };
    /**
    * @typedef {Object} toggleClickShoeMemberLoginProofingParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} screenName - builder/bo
    * @property {string} value - on/off
    **/
    /**
     * Name: Toggle Click Shoe Member Login Proofing. Evid: 257.
     * Event description: when user change the toggle in the show member login.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * screenName - Type: string. Desc: builder/bo
     *
     * value - Type: string. Desc: on/off
     * @param {toggleClickShoeMemberLoginProofingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.toggleClickShoeMemberLoginProofing = function (params) {
        return this.bi.log(__assign({ evid: 257 }, params));
    };
    /**
    * @typedef {Object} editorSelectAllImagesParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_select_all_images. Evid: 137.
     * Event description: editor_select_all_images.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * set_id - Type: string. Desc: -
     * @param {editorSelectAllImagesParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorSelectAllImages = function (params) {
        return this.bi.log(__assign({ evid: 137 }, params));
    };
    /**
    * @typedef {Object} oaGalleryShareParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA gallery share. Evid: 515.
     * Event description: user clicks to invite others to the gallery site in One App.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {oaGalleryShareParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleryShare = function (params) {
        return this.bi.log(__assign({ evid: 515 }, params));
    };
    /**
    * @typedef {Object} customizeLayoutParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selectedLayout - []
    **/
    /**
     * Name: customize _layout. Evid: 413.
     * Event description: click on customize layout button.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selectedLayout - Type: string. Desc: []
     * @param {customizeLayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.customizeLayout = function (params) {
        return this.bi.log(__assign({ evid: 413 }, params));
    };
    /**
    * @typedef {Object} singleImageSettingsCancelParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Single image settings - Cancel. Evid: 422.
     * Event description: User clicks on Cancel (or closes) when in Single Image settings in the organize media.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {singleImageSettingsCancelParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.singleImageSettingsCancel = function (params) {
        return this.bi.log(__assign({ evid: 422 }, params));
    };
    /**
    * @typedef {Object} popupAlbumIsNotPublishedProofingParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Popup Album Is Not Published Proofing. Evid: 264.
     * Event description: when the pop up of album is not publish when a user try to create a list in the proofing.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {popupAlbumIsNotPublishedProofingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popupAlbumIsNotPublishedProofing = function (params) {
        return this.bi.log(__assign({ evid: 264 }, params));
    };
    /**
    * @typedef {Object} organizeMediaClickActionButtonParams
    * @property {string} buttonName - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} source - .
    * @property {string} value - []
    **/
    /**
     * Name: Organize Media - Click Action Button. Evid: 276.
     * Event description: user clicks an action button in the organize media.
    
     * buttonName - Type: string. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * source - Type: string. Desc: .
     *
     * value - Type: string. Desc: []
     * @param {organizeMediaClickActionButtonParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.organizeMediaClickActionButton = function (params) {
        return this.bi.log(__assign({ evid: 276 }, params));
    };
    /**
    * @typedef {Object} editorSetPermissionParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selection - {public, private, hide}
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_set_permission. Evid: 143.
     * Event description: editor_set_permission.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {public, private, hide}
     *
     * set_id - Type: string. Desc: -
     * @param {editorSetPermissionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorSetPermission = function (params) {
        return this.bi.log(__assign({ evid: 143 }, params));
    };
    /**
    * @typedef {Object} clickOnInviteMemberToCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click On Invite Member To Collection. Evid: 233.
     * Event description: click on invite member to collection.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnInviteMemberToCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnInviteMemberToCollection = function (params) {
        return this.bi.log(__assign({ evid: 233 }, params));
    };
    /**
    * @typedef {Object} artStoreChooseSellingMethodParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} selling_method - selling_method
    * @property {string} source - start now/ change selling method
    **/
    /**
     * Name: art store --> choose selling method. Evid: 730.
     * Event description: choose the selling method.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * selling_method - Type: string. Desc: selling_method
     *
     * source - Type: string. Desc: start now/ change selling method
     * @param {artStoreChooseSellingMethodParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.artStoreChooseSellingMethod = function (params) {
        return this.bi.log(__assign({ evid: 730 }, params));
    };
    /**
    * @typedef {Object} clickCreateAlIstInTheBuilderParams
    * @property {string} albumID - album_id
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Click Create A lIst In The Builder. Evid: 262.
     * Event description: when user click in the builder create a list.
    
     * albumID - Type: string. Desc: album_id
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {clickCreateAlIstInTheBuilderParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickCreateAlIstInTheBuilder = function (params) {
        return this.bi.log(__assign({ evid: 262 }, params));
    };
    /**
    * @typedef {Object} licenseQualityToggleParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - license name
    * @property {GUID} storeId - gallery_id
    * @property {string} type - license type
    * @property {string} value - true/false
    **/
    /**
     * Name: license-->quality toggle. Evid: 718.
     * Event description: check/uncheck license quality.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: license name
     *
     * storeId - Type: guid. Desc: gallery_id
     *
     * type - Type: string. Desc: license type
     *
     * value - Type: string. Desc: true/false
     * @param {licenseQualityToggleParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseQualityToggle = function (params) {
        return this.bi.log(__assign({ evid: 718 }, params));
    };
    /**
    * @typedef {Object} proGallerySettingsStartNowParams
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: pro gallery settings --> start now. Evid: 182.
     * Event description: open store gallery in app market from Pro gallery settings.
    
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {proGallerySettingsStartNowParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.proGallerySettingsStartNow = function (params) {
        return this.bi.log(__assign({ evid: 182 }, params));
    };
    /**
    * @typedef {Object} photoAlbumStoreCompletedBusinessInfoParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    * @property {string} page_name - orders/licenses/payment/bus info
    * @property {GUID} providerId - provider id
    **/
    /**
     * Name: Photo Album store --> completed business info. Evid: 188.
     * Event description: user completed setting a payment method or completed store information depends on provider.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * page_name - Type: string. Desc: orders/licenses/payment/bus info
     *
     * providerId - Type: guid. Desc: provider id
     * @param {photoAlbumStoreCompletedBusinessInfoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumStoreCompletedBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 188 }, params));
    };
    /**
    * @typedef {Object} photoAlbumLoadUsersParams
    * @property {string} endpoint - []
    * @property {GUID} instance_id - null
    * @property {number} loading_time - []
    * @property {GUID} biToken - null
    **/
    /**
     * Name: photo album load-->users. Evid: 176.
     * Event description: photo album end point users client.
    
     * endpoint - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * loading_time - Type: numeric. Desc: []
     *
     * biToken - Type: guid.
     * @param {photoAlbumLoadUsersParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumLoadUsers = function (params) {
        return this.bi.log(__assign({ evid: 176 }, params));
    };
    /**
    * @typedef {Object} imageThumbnailCreatedParams
    * @property {string} albumID - .
    * @property {string} batchId - .
    * @property {string} correlationId - .
    * @property {number} fileSize - in bits
    * @property {GUID} instance_id - null
    * @property {boolean} isSecure - .
    * @property {string} mediatype - .
    * @property {GUID} biToken - null
    * @property {string} origin - .
    * @property {string} setID - .
    **/
    /**
     * Name: Image Thumbnail Created. Evid: 194.
     * Event description: when uploading an image to media, a thumbnail for pre-load image is created until the full image is uploaded. This events monitors the thumbnail..
    
     * albumID - Type: string. Desc: .
     *
     * batchId - Type: string. Desc: .
     *
     * correlationId - Type: string. Desc: .
     *
     * fileSize - Type: numeric. Desc: in bits
     *
     * instance_id - Type: guid.
     *
     * isSecure - Type: bool. Desc: .
     *
     * mediatype - Type: string. Desc: .
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: .
     *
     * setID - Type: string. Desc: .
     * @param {imageThumbnailCreatedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.imageThumbnailCreated = function (params) {
        return this.bi.log(__assign({ evid: 194 }, params));
    };
    /**
    * @typedef {Object} organizeMediaEditQualityClickParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} itemId - item id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Organize Media - Edit quality click. Evid: 420.
     * Event description: User clicks on Edit Image Quality in Organize media window.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * itemId - Type: string. Desc: item id
     *
     * biToken - Type: guid.
     * @param {organizeMediaEditQualityClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.organizeMediaEditQualityClick = function (params) {
        return this.bi.log(__assign({ evid: 420 }, params));
    };
    /**
    * @typedef {Object} galleryPerformanceParams
    * @property {string} additional_info - {}
    * @property {GUID} gallery_id - -
    * @property {GUID} instance_id - null
    * @property {string} measure_type - {}
    * @property {number} media_size - -
    * @property {GUID} biToken - null
    * @property {number} time - -
    **/
    /**
     * Name: gallery_performance. Evid: 410.
     * Event description: gallery loading stats.
    
     * additional_info - Type: string. Desc: {}
     *
     * gallery_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * measure_type - Type: string. Desc: {}
     *
     * media_size - Type: numeric. Desc: -
     *
     * biToken - Type: guid.
     *
     * time - Type: numeric. Desc: -
     * @param {galleryPerformanceParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.galleryPerformance = function (params) {
        return this.bi.log(__assign({ evid: 410 }, params));
    };
    /**
    * @typedef {Object} licenseSetPriceParams
    * @property {string} app_id - []
    * @property {string} currency - currency
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} name - license name
    * @property {number} price - price
    * @property {GUID} storeId - gallery_id
    * @property {string} type - license type
    * @property {string} value - true/false
    **/
    /**
     * Name: license-->set price. Evid: 720.
     * Event description: set the price.
    
     * app_id - Type: string. Desc: []
     *
     * currency - Type: string. Desc: currency
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * name - Type: string. Desc: license name
     *
     * price - Type: numeric. Desc: price
     *
     * storeId - Type: guid. Desc: gallery_id
     *
     * type - Type: string. Desc: license type
     *
     * value - Type: string. Desc: true/false
     * @param {licenseSetPriceParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.licenseSetPrice = function (params) {
        return this.bi.log(__assign({ evid: 720 }, params));
    };
    /**
    * @typedef {Object} manageStoreLocaleParams
    * @property {string} app_id - []
    * @property {string} category - language/currency/...
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - store_id
    * @property {string} value - value chosen
    **/
    /**
     * Name: manage store-->locale. Evid: 725.
     * Event description: change locale settings.
    
     * app_id - Type: string. Desc: []
     *
     * category - Type: string. Desc: language/currency/...
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid. Desc: store_id
     *
     * value - Type: string. Desc: value chosen
     * @param {manageStoreLocaleParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageStoreLocale = function (params) {
        return this.bi.log(__assign({ evid: 725 }, params));
    };
    /**
    * @typedef {Object} openWizardCreateCollectionParams
    * @property {string} albumID - album_id
    * @property {string} button_name - bzm top button/ bzm + sign / members area
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Open Wizard Create Collection. Evid: 208.
     * Event description: when user open create collection wizard ( create collection from bo/members area).
    
     * albumID - Type: string. Desc: album_id
     *
     * button_name - Type: string. Desc: bzm top button/ bzm + sign / members area
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {openWizardCreateCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openWizardCreateCollection = function (params) {
        return this.bi.log(__assign({ evid: 208 }, params));
    };
    /**
    * @typedef {Object} oaArtStoreViewOrderParams
    * @property {GUID} album_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - null
    * @property {GUID} orderId - []
    * @property {string} origin - []
    * @property {GUID} providerId - GUID of provider
    * @property {string} store_type - album or art store
    **/
    /**
     * Name: OA Art Store - View Order. Evid: 541.
     * Event description: user clicks to view order in art store.
    
     * album_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid.
     *
     * orderId - Type: guid. Desc: []
     *
     * origin - Type: string. Desc: []
     *
     * providerId - Type: guid. Desc: GUID of provider
     *
     * store_type - Type: string. Desc: album or art store
     * @param {oaArtStoreViewOrderParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaArtStoreViewOrder = function (params) {
        return this.bi.log(__assign({ evid: 541 }, params));
    };
    /**
    * @typedef {Object} closeDialogParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} type - {create_new_site,photos,design,details,settings,help,publish}
    **/
    /**
     * Name: close_dialog. Evid: 127.
     * Event description: editor_settings_edit- saved on blur.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * type - Type: string. Desc: {create_new_site,photos,design,details,settings,help,publish}
     * @param {closeDialogParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.closeDialog = function (params) {
        return this.bi.log(__assign({ evid: 127 }, params));
    };
    /**
    * @typedef {Object} refreshSeoParamsStartedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: refresh_SEO_params_started. Evid: 168.
     * Event description: refresh_SEO_params_started.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {refreshSeoParamsStartedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.refreshSeoParamsStarted = function (params) {
        return this.bi.log(__assign({ evid: 168 }, params));
    };
    /**
    * @typedef {Object} publishParams
    * @property {string} album_id - -
    * @property {string} album_url - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: publish. Evid: 146.
     * Event description: publish album site.
    
     * album_id - Type: string. Desc: -
     *
     * album_url - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {publishParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.publish = function (params) {
        return this.bi.log(__assign({ evid: 146 }, params));
    };
    /**
    * @typedef {Object} popupAlbumIsNotPublishedClickProofingParams
    * @property {string} albumID - album_id
    * @property {string} buttonName - go to album / cancel
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Popup Album Is Not Published Click Proofing. Evid: 265.
     * Event description: when the user click in on the banner the album is not publish.
    
     * albumID - Type: string. Desc: album_id
     *
     * buttonName - Type: string. Desc: go to album / cancel
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {popupAlbumIsNotPublishedClickProofingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popupAlbumIsNotPublishedClickProofing = function (params) {
        return this.bi.log(__assign({ evid: 265 }, params));
    };
    /**
    * @typedef {Object} newPhotoSiteParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} selection - {help,feedback}
    **/
    /**
     * Name: new_photo_site. Evid: 102.
     * Event description: new_photo_site click.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * selection - Type: string. Desc: {help,feedback}
     * @param {newPhotoSiteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.newPhotoSite = function (params) {
        return this.bi.log(__assign({ evid: 102 }, params));
    };
    /**
    * @typedef {Object} userClickAfterCreateListParams
    * @property {string} albumID - album_id
    * @property {string} buttonName - done / view list / exit
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: User Click After Create List. Evid: 268.
     * Event description: when the user finish to create a list the click in the banner.
    
     * albumID - Type: string. Desc: album_id
     *
     * buttonName - Type: string. Desc: done / view list / exit
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {userClickAfterCreateListParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.userClickAfterCreateList = function (params) {
        return this.bi.log(__assign({ evid: 268 }, params));
    };
    /**
    * @typedef {Object} oaGalleryVisibilityInGalleriesSettingsParams
    * @property {string} category - visible or hided
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA gallery visibility in galleries settings. Evid: 526.
     * Event description: user filters a gallery in the settings of the manage gallery in OA (also event 523 has hide and show params).
    
     * category - Type: string. Desc: visible or hided
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     * @param {oaGalleryVisibilityInGalleriesSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleryVisibilityInGalleriesSettings = function (params) {
        return this.bi.log(__assign({ evid: 526 }, params));
    };
    /**
    * @typedef {Object} oaClickOnMediaParams
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - null
    * @property {string} layout_type - []
    * @property {number} media_index - position of the media in gallery
    * @property {string} media_type - []
    * @property {GUID} biToken - null
    **/
    /**
     * Name: OA click on media. Evid: 516.
     * Event description: user clicks on a media in a gallery.
    
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid.
     *
     * layout_type - Type: string. Desc: []
     *
     * media_index - Type: numeric. Desc: position of the media in gallery
     *
     * media_type - Type: string. Desc: []
     *
     * biToken - Type: guid.
     * @param {oaClickOnMediaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaClickOnMedia = function (params) {
        return this.bi.log(__assign({ evid: 516 }, params));
    };
    /**
    * @typedef {Object} manageStoreLoadParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - []
    **/
    /**
     * Name: manage store-->load. Evid: 726.
     * Event description: the store manager loaded.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid. Desc: []
     * @param {manageStoreLoadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageStoreLoad = function (params) {
        return this.bi.log(__assign({ evid: 726 }, params));
    };
    /**
    * @typedef {Object} changeWatermarkParams
    * @property {GUID} gallery_id - []
    * @property {string} galleryType - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} watermark - []
    **/
    /**
     * Name: Change Watermark. Evid: 414.
     * Event description: When a request to change watermark is sent to server.
    
     * gallery_id - Type: guid. Desc: []
     *
     * galleryType - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * watermark - Type: string. Desc: []
     * @param {changeWatermarkParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.changeWatermark = function (params) {
        return this.bi.log(__assign({ evid: 414 }, params));
    };
    /**
    * @typedef {Object} actionInCollectionsCommentsModalParams
    * @property {string} albumID - album_id
    * @property {number} amount - num of comments
    * @property {string} buttonName - null
    * @property {string} collection_id - null
    * @property {GUID} instance_id - instance_id
    * @property {string} itemId - null
    * @property {GUID} biToken - -
    * @property {string} role - the role in the album (owner/member)
    * @property {string} source - null
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Action in collections comments modal. Evid: 282.
    
    
     * albumID - Type: string. Desc: album_id
     *
     * amount - Type: numeric. Desc: num of comments
     *
     * buttonName - Type: string.
     *
     * collection_id - Type: string.
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * itemId - Type: string.
     *
     * biToken - Type: guid. Desc: -
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * source - Type: string.
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {actionInCollectionsCommentsModalParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.actionInCollectionsCommentsModal = function (params) {
        return this.bi.log(__assign({ evid: 282 }, params));
    };
    /**
    * @typedef {Object} clickOnSelectMediaCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click On Select Media Collection. Evid: 228.
     * Event description: Arrived when visitor click on start select media in collection.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnSelectMediaCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnSelectMediaCollection = function (params) {
        return this.bi.log(__assign({ evid: 228 }, params));
    };
    /**
    * @typedef {Object} generateDownloadLinkStartedParams
    * @property {string} album_id - -
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {number} number_of_photos - -
    * @property {string} set_id - -
    **/
    /**
     * Name: generate_download_link_started. Evid: 161.
     * Event description: generate_download_link_started.
    
     * album_id - Type: string. Desc: -
     *
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * number_of_photos - Type: numeric. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {generateDownloadLinkStartedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.generateDownloadLinkStarted = function (params) {
        return this.bi.log(__assign({ evid: 161 }, params));
    };
    /**
    * @typedef {Object} clickOn3DotsActionProofingListParams
    * @property {string} albumID - album_id
    * @property {string} buttonName - action name
    * @property {string} collection_id - unique id for coellection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click On 3 Dots Action Proofing list. Evid: 272.
     * Event description: when user click on action from 3 dots menu in proofing list.
    
     * albumID - Type: string. Desc: album_id
     *
     * buttonName - Type: string. Desc: action name
     *
     * collection_id - Type: string. Desc: unique id for coellection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOn3DotsActionProofingListParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOn3DotsActionProofingList = function (params) {
        return this.bi.log(__assign({ evid: 272 }, params));
    };
    /**
    * @typedef {Object} editorSettingsEditParams
    * @property {GUID} app_site_id - -
    * @property {string} field - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} new_value - -
    * @property {string} photo_site_id - -
    **/
    /**
     * Name: editor_settings_edit. Evid: 126.
     * Event description: editor_settings_edit- saved on blur.
    
     * app_site_id - Type: guid. Desc: -
     *
     * field - Type: string. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * new_value - Type: string. Desc: -
     *
     * photo_site_id - Type: string. Desc: -
     * @param {editorSettingsEditParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorSettingsEdit = function (params) {
        return this.bi.log(__assign({ evid: 126 }, params));
    };
    /**
    * @typedef {Object} clickOnViewCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} source - bzm/member area
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click On View Collection. Evid: 217.
     * Event description: when user click on view collection.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * source - Type: string. Desc: bzm/member area
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnViewCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnViewCollection = function (params) {
        return this.bi.log(__assign({ evid: 217 }, params));
    };
    /**
    * @typedef {Object} oaGalleryErrorParams
    * @property {string} app_id - []
    * @property {number} count - []
    * @property {string} errorMessage - []
    * @property {GUID} gallery_id - []
    * @property {GUID} instance_id - []
    * @property {string} media_type - type of media (images, video, mixed)
    * @property {GUID} biToken - []
    * @property {string} params - Json with gallery name and boolean values for Share, Download, Display
    * @property {string} source - device, media manager, camera
    **/
    /**
     * Name: OA Gallery - Error. Evid: 550.
     * Event description: an error occurred during Gallery creation flow.
    
     * app_id - Type: string. Desc: []
     *
     * count - Type: numeric. Desc: []
     *
     * errorMessage - Type: string. Desc: []
     *
     * gallery_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * media_type - Type: string. Desc: type of media (images, video, mixed)
     *
     * biToken - Type: guid. Desc: []
     *
     * params - Type: string. Desc: Json with gallery name and boolean values for Share, Download, Display
     *
     * source - Type: string. Desc: device, media manager, camera
     * @param {oaGalleryErrorParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaGalleryError = function (params) {
        return this.bi.log(__assign({ evid: 550 }, params));
    };
    /**
    * @typedef {Object} settingsClickViewAlbumsListParams
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} origin - Main
    **/
    /**
     * Name: Settings_click_view_albums_list. Evid: 238.
     * Event description: click on view albums list button.
    
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: Main
     * @param {settingsClickViewAlbumsListParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.settingsClickViewAlbumsList = function (params) {
        return this.bi.log(__assign({ evid: 238 }, params));
    };
    /**
    * @typedef {Object} editorEditSetParams
    * @property {GUID} app_site_id - -
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} photo_site_id - -
    * @property {string} set_id - -
    **/
    /**
     * Name: editor_edit_set. Evid: 119.
     * Event description: editor_edit_set.
    
     * app_site_id - Type: guid. Desc: -
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * photo_site_id - Type: string. Desc: -
     *
     * set_id - Type: string. Desc: -
     * @param {editorEditSetParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.editorEditSet = function (params) {
        return this.bi.log(__assign({ evid: 119 }, params));
    };
    /**
    * @typedef {Object} oaCollectionViewedParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - -
    * @property {string} origin - collection settings/ new collection / LiveSite
    * @property {string} params - collection params
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: OA Collection Viewed. Evid: 274.
     * Event description: Collection viewed in OA.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: -
     *
     * origin - Type: string. Desc: collection settings/ new collection / LiveSite
     *
     * params - Type: string. Desc: collection params
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {oaCollectionViewedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaCollectionViewed = function (params) {
        return this.bi.log(__assign({ evid: 274 }, params));
    };
    /**
    * @typedef {Object} clickOnViewAndEditProofingListParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for coellection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    * @property {string} role - the role in the collection (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Click On View And Edit Proofing List. Evid: 270.
     * Event description: when the user click on view and edit a proofing list.
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for coellection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     *
     * role - Type: string. Desc: the role in the collection (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {clickOnViewAndEditProofingListParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickOnViewAndEditProofingList = function (params) {
        return this.bi.log(__assign({ evid: 270 }, params));
    };
    /**
    * @typedef {Object} albumPublishPopupParams
    * @property {GUID} app_site_id - app_site_id
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} pop_up_type - {Free,Premium_wo_domain,Premium_w_domain}
    **/
    /**
     * Name: album_publish_popup. Evid: 173.
     * Event description: show album publish pop up.
    
     * app_site_id - Type: guid. Desc: app_site_id
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * pop_up_type - Type: string. Desc: {Free,Premium_wo_domain,Premium_w_domain}
     * @param {albumPublishPopupParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.albumPublishPopup = function (params) {
        return this.bi.log(__assign({ evid: 173 }, params));
    };
    /**
    * @typedef {Object} uploadMediaParams
    * @property {string} actionType - new/replace
    * @property {number} count - null
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - null
    * @property {boolean} is_store - null
    * @property {GUID} biToken - null
    * @property {string} type - null
    **/
    /**
     * Name: upload_media. Evid: 406.
     * Event description: Upload_media.
    
     * actionType - Type: string. Desc: new/replace
     *
     * count - Type: numeric.
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid.
     *
     * is_store - Type: bool.
     *
     * biToken - Type: guid.
     *
     * type - Type: string.
     * @param {uploadMediaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.uploadMedia = function (params) {
        return this.bi.log(__assign({ evid: 406 }, params));
    };
    /**
    * @typedef {Object} galleryPublishedParams
    * @property {number} numberOfItems - images in gallery
    * @property {GUID} gallery_id - null
    * @property {string} galleryType - pro / store / album
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {string} styleParams - json
    * @property {string} rawStyleParams - json with changed params only (for mobile usage)
    **/
    /**
     * Name: gallery_published. Evid: 412.
     * Event description: the event contains a json with all the params of the gallery at the moment of site publish.
    
     * numberOfItems - Type: numeric. Desc: images in gallery
     *
     * gallery_id - Type: guid.
     *
     * galleryType - Type: string. Desc: pro / store / album
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * styleParams - Type: string. Desc: json
     *
     * rawStyleParams - Type: string. Desc: json with changed params only (for mobile usage)
     * @param {galleryPublishedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.galleryPublished = function (params) {
        return this.bi.log(__assign({ evid: 412 }, params));
    };
    /**
    * @typedef {Object} viewItemCommentInCollectionParams
    * @property {string} albumID - album_id
    * @property {number} amount - num of comments
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {string} itemId - id of the chosen item
    * @property {GUID} biToken - -
    * @property {string} role - the role in the album (owner/member)
    * @property {string} source - BM
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: View Item Comments in Collection. Evid: 281.
     * Event description: Users clicks on comments to view them.
    
     * albumID - Type: string. Desc: album_id
     *
     * amount - Type: numeric. Desc: num of comments
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * itemId - Type: string. Desc: id of the chosen item
     *
     * biToken - Type: guid. Desc: -
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * source - Type: string. Desc: BM
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {viewItemCommentInCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.viewItemCommentInCollection = function (params) {
        return this.bi.log(__assign({ evid: 281 }, params));
    };
    /**
    * @typedef {Object} actionInCollectionParams
    * @property {string} albumID - album_id
    * @property {string} collection_id - unique id for collection
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - -
    * @property {string} origin - origin of action
    * @property {string} params - collection params
    * @property {string} role - the role in the album (owner/member)
    * @property {string} visitorId - id of the member in the collection
    **/
    /**
     * Name: Action in collection. Evid: 280.
     * Event description: Add or remove image from list (collection).
    
     * albumID - Type: string. Desc: album_id
     *
     * collection_id - Type: string. Desc: unique id for collection
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid. Desc: -
     *
     * origin - Type: string. Desc: origin of action
     *
     * params - Type: string. Desc: collection params
     *
     * role - Type: string. Desc: the role in the album (owner/member)
     *
     * visitorId - Type: string. Desc: id of the member in the collection
     * @param {actionInCollectionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.actionInCollection = function (params) {
        return this.bi.log(__assign({ evid: 280 }, params));
    };
    /**
    * @typedef {Object} photoAlbumItemOnActionParams
    * @property {string} actionName - []
    * @property {string} albumID - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - null
    * @property {string} screenName - []
    * @property {string} value - []
    **/
    /**
     * Name: PhotoAlbum.Item.onAction. Evid: 213.
     * Event description: generic action performed by the user.
    
     * actionName - Type: string. Desc: []
     *
     * albumID - Type: string. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid.
     *
     * screenName - Type: string. Desc: []
     *
     * value - Type: string. Desc: []
     * @param {photoAlbumItemOnActionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.photoAlbumItemOnAction = function (params) {
        return this.bi.log(__assign({ evid: 213 }, params));
    };
    /**
    * @typedef {Object} endUploadToMediaSingleItemParams
    * @property {string} albumID - null
    * @property {string} batchId - .
    * @property {string} correlationID - Instead of the lacking file_id
    * @property {number} duration - Time to upload in milliseconds
    * @property {string} error - error reason
    * @property {number} fileSize - null
    * @property {GUID} instance_id - null
    * @property {boolean} isSecure - Upload to Secured Media or not
    * @property {string} mediaType - null
    * @property {string} mediaURL - .
    * @property {GUID} biToken - null
    * @property {string} origin - .
    * @property {number} retryCount - How many times the file tried to reload
    * @property {string} setID - .
    * @property {string} status - succeed/failed
    **/
    /**
     * Name: End Upload To Media - Single Item. Evid: 191.
     * Event description: Indicates the end of a single-file upload.
    
     * albumID - Type: string.
     *
     * batchId - Type: string. Desc: .
     *
     * correlationID - Type: string. Desc: Instead of the lacking file_id
     *
     * duration - Type: numeric. Desc: Time to upload in milliseconds
     *
     * error - Type: string. Desc: error reason
     *
     * fileSize - Type: numeric.
     *
     * instance_id - Type: guid.
     *
     * isSecure - Type: bool. Desc: Upload to Secured Media or not
     *
     * mediaType - Type: string.
     *
     * mediaURL - Type: string. Desc: .
     *
     * biToken - Type: guid.
     *
     * origin - Type: string. Desc: .
     *
     * retryCount - Type: numeric. Desc: How many times the file tried to reload
     *
     * setID - Type: string. Desc: .
     *
     * status - Type: string. Desc: succeed/failed
     * @param {endUploadToMediaSingleItemParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.endUploadToMediaSingleItem = function (params) {
        return this.bi.log(__assign({ evid: 191 }, params));
    };
    /**
    * @typedef {Object} manageStoreAddLogoParams
    * @property {string} app_id - []
    * @property {GUID} instance_id - null
    * @property {GUID} biToken - null
    * @property {GUID} storeId - gallery_id
    **/
    /**
     * Name: manage store-->add logo. Evid: 724.
     * Event description: add your logo.
    
     * app_id - Type: string. Desc: []
     *
     * instance_id - Type: guid.
     *
     * biToken - Type: guid.
     *
     * storeId - Type: guid. Desc: gallery_id
     * @param {manageStoreAddLogoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.manageStoreAddLogo = function (params) {
        return this.bi.log(__assign({ evid: 724 }, params));
    };
    /**
    * @typedef {Object} oaArtStoreContactCustomerParams
    * @property {GUID} album_id - []
    * @property {GUID} instance_id - []
    * @property {GUID} biToken - null
    * @property {GUID} orderId - []
    * @property {GUID} providerId - []
    * @property {string} store_type - []
    * @property {string} type - contact type
    **/
    /**
     * Name: OA Art Store - Contact customer. Evid: 542.
     * Event description: user clicks to contact customer.
    
     * album_id - Type: guid. Desc: []
     *
     * instance_id - Type: guid. Desc: []
     *
     * biToken - Type: guid.
     *
     * orderId - Type: guid. Desc: []
     *
     * providerId - Type: guid. Desc: []
     *
     * store_type - Type: string. Desc: []
     *
     * type - Type: string. Desc: contact type
     * @param {oaArtStoreContactCustomerParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.oaArtStoreContactCustomer = function (params) {
        return this.bi.log(__assign({ evid: 542 }, params));
    };
    /**
    * @typedef {Object} receivedMediaToUploadParams
    * @property {number} count - -
    * @property {GUID} gallery_id - []
    * @property {string} galleryType - store/pro/photo/album
    * @property {GUID} instance_id - []
    * @property {boolean} is_store - []
    * @property {GUID} biToken - []
    * @property {string} type - []
    **/
    /**
     * Name: Received Media To Upload. Evid: 275.
     * Event description: when media is received to upload.
    
     * count - Type: numeric. Desc: -
     *
     * gallery_id - Type: guid. Desc: []
     *
     * galleryType - Type: string. Desc: store/pro/photo/album
     *
     * instance_id - Type: guid. Desc: []
     *
     * is_store - Type: bool. Desc: []
     *
     * biToken - Type: guid. Desc: []
     *
     * type - Type: string. Desc: []
     * @param {receivedMediaToUploadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.receivedMediaToUpload = function (params) {
        return this.bi.log(__assign({ evid: 275 }, params));
    };
    /**
    * @typedef {Object} popupBannerHideMemberLoginClickParams
    * @property {string} albumID - album_id
    * @property {string} buttonName - Hide / Cancel
    * @property {GUID} instance_id - instance_id
    * @property {GUID} biToken - null
    **/
    /**
     * Name: Popup Banner Hide Member Login Click. Evid: 261.
     * Event description: when the user click in the banner of hide member login click.
    
     * albumID - Type: string. Desc: album_id
     *
     * buttonName - Type: string. Desc: Hide / Cancel
     *
     * instance_id - Type: guid. Desc: instance_id
     *
     * biToken - Type: guid.
     * @param {popupBannerHideMemberLoginClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popupBannerHideMemberLoginClick = function (params) {
        return this.bi.log(__assign({ evid: 261 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 65,
        endpoint: 'photo-users',
    };
}
//# sourceMappingURL=index.js.map